var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalculator(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 880,
    height: 344,
    viewBox: "0 0 880 344",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.ak,.al{fill:none;}.b{clip-path:url(#j);}.c{fill:url(#a);}.d{fill:url(#b);}.e{clip-path:url(#c);}.f{opacity:0.49;}.g,.i,.o{fill:#fcfffe;}.g,.h{opacity:0.29;}.j{opacity:0.44;}.k{fill:rgba(81,67,158,0.1);}.l{fill:rgba(251,188,5,0.1);}.m{opacity:0.1;}.m,.n{fill:url(#d);}.n{opacity:0.33;}.o{opacity:0.39;}.p,.t{fill:#fb9905;}.p,.q{opacity:0.5;}.r{fill:#c89500;}.s{fill:#f1b300;}.u{fill:#fff;}.v{fill:#e6e6e6;}.w{fill:#172b4d;}.x{fill:#3fd267;}.y{fill:#eceff2;}.z{fill:#ff7064;}.aa{fill:#8898aa;}.ab{fill:#cacfd5;}.ac{fill:#34a853;}.ad{fill:#d2d2d2;}.ae{fill:#cbcbcb;}.af{fill:#f1f3f9;}.ag{fill:#dadde4;}.ah{fill:#852a22;}.ai{fill:#952e25;}.aj{fill:#9f2f26;}.ak{stroke:rgba(0,0,0,0.27);}.ak,.al{stroke-width:12px;}.al{stroke:#fcde49;}"), /*#__PURE__*/React.createElement("radialGradient", {
    id: "a",
    cx: 0.014,
    cy: 0.283,
    r: 1.68,
    gradientTransform: "translate(0.167) scale(0.667 1)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ea4335"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffe8e6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 0.324,
    y1: 0.448,
    x2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c2d9ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#679efb"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 880,
    height: 344,
    transform: "translate(0 0)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbbc05",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fbbc05"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "j"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 880,
    height: 344
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "i",
    className: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "u",
    width: 880,
    height: 344
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-68.39 -61.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 880,
    height: 344,
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 880,
    height: 344,
    transform: "translate(68.39 61.12)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "e",
    transform: "translate(68.39 61.12)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "f",
    transform: "translate(-7.873 3.344)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 8.671,
    cy: 8.671,
    r: 8.671
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.861,
    cy: 7.861,
    r: 7.861,
    transform: "translate(0.81 24.253)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.052,
    cy: 7.052,
    r: 7.052,
    transform: "translate(1.619 48.494)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 6.242,
    cy: 6.242,
    r: 6.242,
    transform: "translate(2.429 72.735)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 5.433,
    cy: 5.433,
    r: 5.433,
    transform: "translate(3.238 96.988)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 4.623,
    cy: 4.623,
    r: 4.623,
    transform: "translate(4.048 121.229)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 3.813,
    cy: 3.813,
    r: 3.813,
    transform: "translate(4.858 145.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M4.141,150.5a3.015,3.015,0,1,0-3,3.015,3,3,0,0,0,3-3.015Z",
    transform: "translate(7.545 22.219)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M3.212,170.322a2.206,2.206,0,1,0-.634,1.571,2.206,2.206,0,0,0,.634-1.571Z",
    transform: "translate(7.665 25.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M2.283,190.208A1.4,1.4,0,1,0,.9,191.592,1.385,1.385,0,0,0,2.283,190.208Z",
    transform: "translate(7.785 29.381)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 8.671,
    cy: 8.671,
    r: 8.671,
    transform: "translate(17.342)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.861,
    cy: 7.861,
    r: 7.861,
    transform: "translate(18.151 24.253)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.052,
    cy: 7.052,
    r: 7.052,
    transform: "translate(18.961 48.494)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 6.242,
    cy: 6.242,
    r: 6.242,
    transform: "translate(19.771 72.735)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 5.433,
    cy: 5.433,
    r: 5.433,
    transform: "translate(20.58 96.988)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 4.623,
    cy: 4.623,
    r: 4.623,
    transform: "translate(21.39 121.229)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 3.813,
    cy: 3.813,
    r: 3.813,
    transform: "translate(22.199 145.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M18.891,150.5a3,3,0,1,0-.876,2.132A3.015,3.015,0,0,0,18.891,150.5Z",
    transform: "translate(10.102 22.219)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M17.992,170.328a2.206,2.206,0,1,0-2.194,2.194,2.206,2.206,0,0,0,2.194-2.194Z",
    transform: "translate(10.227 25.795)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M17.063,190.208a1.4,1.4,0,1,0-1.385,1.385A1.4,1.4,0,0,0,17.063,190.208Z",
    transform: "translate(10.347 29.381)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 8.671,
    cy: 8.671,
    r: 8.671,
    transform: "translate(34.684)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.861,
    cy: 7.861,
    r: 7.861,
    transform: "translate(35.493 24.253)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.052,
    cy: 7.052,
    r: 7.052,
    transform: "translate(36.303 48.494)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 6.242,
    cy: 6.242,
    r: 6.242,
    transform: "translate(37.113 72.735)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 5.433,
    cy: 5.433,
    r: 5.433,
    transform: "translate(37.922 96.988)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 4.623,
    cy: 4.623,
    r: 4.623,
    transform: "translate(38.732 121.229)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 3.813,
    cy: 3.813,
    r: 3.813,
    transform: "translate(39.541 145.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M33.7,150.5a3.015,3.015,0,1,0-3.015,3.016A3.015,3.015,0,0,0,33.7,150.5Z",
    transform: "translate(12.669 22.219)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M32.772,170.328a2.206,2.206,0,1,0-2.206,2.194,2.206,2.206,0,0,0,2.206-2.194Z",
    transform: "translate(12.789 25.795)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M31.843,190.208a1.385,1.385,0,1,0-.41.983A1.4,1.4,0,0,0,31.843,190.208Z",
    transform: "translate(12.908 29.381)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 8.671,
    cy: 8.671,
    r: 8.671,
    transform: "translate(52.026)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.861,
    cy: 7.861,
    r: 7.861,
    transform: "translate(52.835 24.253)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.052,
    cy: 7.052,
    r: 7.052,
    transform: "translate(53.645 48.494)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 6.242,
    cy: 6.242,
    r: 6.242,
    transform: "translate(54.454 72.735)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 5.433,
    cy: 5.433,
    r: 5.433,
    transform: "translate(55.264 96.988)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 4.623,
    cy: 4.623,
    r: 4.623,
    transform: "translate(56.074 121.229)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 3.813,
    cy: 3.813,
    r: 3.813,
    transform: "translate(56.883 145.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M48.467,150.492a3,3,0,1,0-.884,2.14,3,3,0,0,0,.884-2.14Z",
    transform: "translate(15.233 22.223)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M47.542,170.322A2.206,2.206,0,1,0,46.9,171.9,2.206,2.206,0,0,0,47.542,170.322Z",
    transform: "translate(15.349 25.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M46.613,190.208a1.385,1.385,0,1,0-.414.987,1.4,1.4,0,0,0,.414-.987Z",
    transform: "translate(15.469 29.381)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 8.671,
    cy: 8.671,
    r: 8.671,
    transform: "translate(69.356)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.861,
    cy: 7.861,
    r: 7.861,
    transform: "translate(70.165 24.253)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.052,
    cy: 7.052,
    r: 7.052,
    transform: "translate(70.975 48.494)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 6.242,
    cy: 6.242,
    r: 6.242,
    transform: "translate(71.785 72.735)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 5.433,
    cy: 5.433,
    r: 5.433,
    transform: "translate(72.594 96.988)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 4.623,
    cy: 4.623,
    r: 4.623,
    transform: "translate(73.404 121.229)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 3.813,
    cy: 3.813,
    r: 3.813,
    transform: "translate(74.213 145.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M63.251,150.5a3,3,0,1,0-.876,2.132A3.015,3.015,0,0,0,63.251,150.5Z",
    transform: "translate(17.791 22.219)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M62.322,170.328a2.206,2.206,0,1,0-2.194,2.194,2.206,2.206,0,0,0,2.194-2.194Z",
    transform: "translate(17.911 25.795)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M61.413,190.208a1.4,1.4,0,1,0-1.385,1.385A1.4,1.4,0,0,0,61.413,190.208Z",
    transform: "translate(18.034 29.381)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 8.671,
    cy: 8.671,
    r: 8.671,
    transform: "translate(86.698)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.861,
    cy: 7.861,
    r: 7.861,
    transform: "translate(87.507 24.253)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.052,
    cy: 7.052,
    r: 7.052,
    transform: "translate(88.317 48.494)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 6.242,
    cy: 6.242,
    r: 6.242,
    transform: "translate(89.126 72.735)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 5.433,
    cy: 5.433,
    r: 5.433,
    transform: "translate(89.936 96.988)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 4.623,
    cy: 4.623,
    r: 4.623,
    transform: "translate(90.746 121.229)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 3.813,
    cy: 3.813,
    r: 3.813,
    transform: "translate(91.555 145.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M78.031,150.5a3.015,3.015,0,1,0-3.015,3.016,3.015,3.015,0,0,0,3.015-3.016Z",
    transform: "translate(20.353 22.219)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M77.1,170.328a2.206,2.206,0,1,0-2.206,2.194,2.206,2.206,0,0,0,2.206-2.194Z",
    transform: "translate(20.473 25.795)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M76.173,190.208a1.385,1.385,0,1,0-.41.983A1.4,1.4,0,0,0,76.173,190.208Z",
    transform: "translate(20.592 29.381)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 8.671,
    cy: 8.671,
    r: 8.671,
    transform: "translate(104.039)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.861,
    cy: 7.861,
    r: 7.861,
    transform: "translate(104.849 24.253)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.052,
    cy: 7.052,
    r: 7.052,
    transform: "translate(105.659 48.494)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 6.242,
    cy: 6.242,
    r: 6.242,
    transform: "translate(106.468 72.735)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 5.433,
    cy: 5.433,
    r: 5.433,
    transform: "translate(107.278 96.988)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 4.623,
    cy: 4.623,
    r: 4.623,
    transform: "translate(108.087 121.229)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 3.813,
    cy: 3.813,
    r: 3.813,
    transform: "translate(108.897 145.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M92.8,150.492a3,3,0,1,0-.876,2.132,3,3,0,0,0,.876-2.132Z",
    transform: "translate(22.917 22.223)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M91.872,170.328a2.206,2.206,0,1,0-2.194,2.194,2.206,2.206,0,0,0,2.194-2.194Z",
    transform: "translate(23.033 25.795)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M90.943,190.208a1.4,1.4,0,1,0-1.385,1.385,1.4,1.4,0,0,0,1.385-1.385Z",
    transform: "translate(23.152 29.381)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 8.671,
    cy: 8.671,
    r: 8.671,
    transform: "translate(121.37)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.861,
    cy: 7.861,
    r: 7.861,
    transform: "translate(122.179 24.253)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.052,
    cy: 7.052,
    r: 7.052,
    transform: "translate(122.989 48.494)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 6.242,
    cy: 6.242,
    r: 6.242,
    transform: "translate(123.798 72.735)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 5.433,
    cy: 5.433,
    r: 5.433,
    transform: "translate(124.608 96.988)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 4.623,
    cy: 4.623,
    r: 4.623,
    transform: "translate(125.418 121.229)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 3.813,
    cy: 3.813,
    r: 3.813,
    transform: "translate(126.227 145.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M107.581,150.5a3,3,0,1,0-.876,2.132,3.015,3.015,0,0,0,.876-2.132Z",
    transform: "translate(25.475 22.219)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M106.652,170.328a2.206,2.206,0,1,0-2.194,2.194,2.206,2.206,0,0,0,2.194-2.194Z",
    transform: "translate(25.595 25.795)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M105.723,190.208a1.4,1.4,0,1,0-1.385,1.385A1.4,1.4,0,0,0,105.723,190.208Z",
    transform: "translate(25.714 29.381)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 8.671,
    cy: 8.671,
    r: 8.671,
    transform: "translate(138.711)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.861,
    cy: 7.861,
    r: 7.861,
    transform: "translate(139.521 24.253)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.052,
    cy: 7.052,
    r: 7.052,
    transform: "translate(140.331 48.494)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 6.242,
    cy: 6.242,
    r: 6.242,
    transform: "translate(141.14 72.735)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 5.433,
    cy: 5.433,
    r: 5.433,
    transform: "translate(141.95 96.988)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 4.623,
    cy: 4.623,
    r: 4.623,
    transform: "translate(142.759 121.229)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M123.29,130.647a3.813,3.813,0,1,0-1.121,2.7,3.825,3.825,0,0,0,1.121-2.7Z",
    transform: "translate(27.917 18.636)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M122.361,150.5a3.015,3.015,0,1,0-3.015,3.016,3.015,3.015,0,0,0,3.015-3.016Z",
    transform: "translate(28.037 22.219)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M121.432,170.328a2.206,2.206,0,1,0-2.206,2.194,2.206,2.206,0,0,0,2.206-2.194Z",
    transform: "translate(28.156 25.795)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M120.5,190.208a1.385,1.385,0,1,0-.41.983,1.4,1.4,0,0,0,.41-.983Z",
    transform: "translate(28.276 29.381)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 8.671,
    cy: 8.671,
    r: 8.671,
    transform: "translate(156.053)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.861,
    cy: 7.861,
    r: 7.861,
    transform: "translate(156.863 24.253)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.052,
    cy: 7.052,
    r: 7.052,
    transform: "translate(157.672 48.494)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 6.242,
    cy: 6.242,
    r: 6.242,
    transform: "translate(158.482 72.735)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M139.915,90.933a5.433,5.433,0,1,0-5.433,5.433,5.433,5.433,0,0,0,5.433-5.433Z",
    transform: "translate(30.242 11.476)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M138.986,110.793a4.623,4.623,0,1,0-4.623,4.623,4.623,4.623,0,0,0,4.623-4.623Z",
    transform: "translate(30.361 15.059)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M138.057,130.643a3.8,3.8,0,1,0-1.113,2.7A3.813,3.813,0,0,0,138.057,130.643Z",
    transform: "translate(30.481 18.64)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M137.127,150.492a3,3,0,1,0-.876,2.132A3,3,0,0,0,137.127,150.492Z",
    transform: "translate(30.6 22.223)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M136.2,170.324A2.194,2.194,0,1,0,134,172.518a2.194,2.194,0,0,0,2.194-2.194Z",
    transform: "translate(30.72 25.798)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M135.273,190.208a1.4,1.4,0,1,0-1.385,1.385A1.4,1.4,0,0,0,135.273,190.208Z",
    transform: "translate(30.836 29.381)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 8.671,
    cy: 8.671,
    r: 8.671,
    transform: "translate(173.383)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.861,
    cy: 7.861,
    r: 7.861,
    transform: "translate(174.193 24.253)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.052,
    cy: 7.052,
    r: 7.052,
    transform: "translate(175.003 48.494)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M155.624,71.082a6.242,6.242,0,1,0-6.242,6.242,6.242,6.242,0,0,0,6.242-6.242Z",
    transform: "translate(32.684 7.895)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M154.7,90.936a5.444,5.444,0,1,0-5.433,5.433,5.444,5.444,0,0,0,5.433-5.433Z",
    transform: "translate(32.8 11.472)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M153.769,110.8a4.635,4.635,0,1,0-4.623,4.623A4.635,4.635,0,0,0,153.769,110.8Z",
    transform: "translate(32.92 15.055)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M152.84,130.647a3.825,3.825,0,1,0-3.813,3.813A3.825,3.825,0,0,0,152.84,130.647Z",
    transform: "translate(33.039 18.636)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M151.891,150.5a3,3,0,1,0-.876,2.132A3.015,3.015,0,0,0,151.891,150.5Z",
    transform: "translate(33.155 22.219)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M150.982,170.328a2.206,2.206,0,1,0-2.194,2.194,2.206,2.206,0,0,0,2.194-2.194Z",
    transform: "translate(33.278 25.795)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M150.053,190.208a1.4,1.4,0,1,0-1.385,1.385A1.4,1.4,0,0,0,150.053,190.208Z",
    transform: "translate(33.398 29.381)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 8.671,
    cy: 8.671,
    r: 8.671,
    transform: "translate(190.725)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.861,
    cy: 7.861,
    r: 7.861,
    transform: "translate(191.535 24.253)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M171.32,51.23a7.04,7.04,0,1,0-7.04,7.04,7.04,7.04,0,0,0,7.04-7.04Z",
    transform: "translate(35.128 4.316)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M170.394,71.082a6.242,6.242,0,1,0-6.242,6.242,6.242,6.242,0,0,0,6.242-6.242Z",
    transform: "translate(35.244 7.895)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M169.465,90.933a5.433,5.433,0,1,0-5.433,5.433A5.433,5.433,0,0,0,169.465,90.933Z",
    transform: "translate(35.364 11.476)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M168.536,110.793a4.623,4.623,0,1,0-4.623,4.623,4.623,4.623,0,0,0,4.623-4.623Z",
    transform: "translate(35.483 15.059)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M167.62,130.647a3.813,3.813,0,1,0-1.121,2.7A3.825,3.825,0,0,0,167.62,130.647Z",
    transform: "translate(35.601 18.636)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M166.691,150.5a3.015,3.015,0,1,0-3.015,3.016,3.015,3.015,0,0,0,3.015-3.016Z",
    transform: "translate(35.721 22.219)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M165.762,170.328a2.206,2.206,0,1,0-2.206,2.194,2.206,2.206,0,0,0,2.206-2.194Z",
    transform: "translate(35.84 25.795)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M164.833,190.208a1.385,1.385,0,1,0-.41.983A1.4,1.4,0,0,0,164.833,190.208Z",
    transform: "translate(35.96 29.381)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 8.671,
    cy: 8.671,
    r: 8.671,
    transform: "translate(208.067)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.861,
    cy: 7.861,
    r: 7.861,
    transform: "translate(208.877 24.253)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M186.08,51.23a7.04,7.04,0,1,0-7.04,7.04A7.04,7.04,0,0,0,186.08,51.23Z",
    transform: "translate(37.686 4.316)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M185.174,71.082a6.242,6.242,0,1,0-1.832,4.418,6.242,6.242,0,0,0,1.832-4.418Z",
    transform: "translate(37.806 7.895)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M184.245,90.933a5.433,5.433,0,1,0-1.6,3.846,5.433,5.433,0,0,0,1.6-3.846Z",
    transform: "translate(37.926 11.476)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M183.366,110.793a4.623,4.623,0,1,0-4.623,4.623,4.623,4.623,0,0,0,4.623-4.623Z",
    transform: "translate(38.054 15.059)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M182.387,130.643a3.8,3.8,0,1,0-1.113,2.7A3.813,3.813,0,0,0,182.387,130.643Z",
    transform: "translate(38.165 18.64)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M181.457,150.492a3,3,0,1,0-.876,2.132,3,3,0,0,0,.876-2.132Z",
    transform: "translate(38.284 22.223)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M180.528,170.319a2.206,2.206,0,1,0-.638,1.575A2.194,2.194,0,0,0,180.528,170.319Z",
    transform: "translate(38.404 25.804)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M179.6,190.2a1.385,1.385,0,1,0-1.385,1.385A1.385,1.385,0,0,0,179.6,190.2Z",
    transform: "translate(38.524 29.385)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 8.671,
    cy: 8.671,
    r: 8.671,
    transform: "translate(225.397)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.861,
    cy: 7.861,
    r: 7.861,
    transform: "translate(226.207 24.253)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.052,
    cy: 7.052,
    r: 7.052,
    transform: "translate(227.016 48.494)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M199.954,71.082a6.242,6.242,0,1,0-6.242,6.242A6.242,6.242,0,0,0,199.954,71.082Z",
    transform: "translate(40.368 7.895)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M199.025,90.933a5.433,5.433,0,1,0-5.433,5.433,5.433,5.433,0,0,0,5.433-5.433Z",
    transform: "translate(40.487 11.476)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M198.1,110.8a4.635,4.635,0,1,0-4.623,4.623A4.635,4.635,0,0,0,198.1,110.8Z",
    transform: "translate(40.603 15.055)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M197.13,130.647a3.825,3.825,0,1,0-3.813,3.813A3.825,3.825,0,0,0,197.13,130.647Z",
    transform: "translate(40.716 18.636)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M196.241,150.5a3,3,0,1,0-.876,2.132,3.015,3.015,0,0,0,.876-2.132Z",
    transform: "translate(40.843 22.219)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M195.312,170.328a2.206,2.206,0,1,0-2.194,2.194,2.206,2.206,0,0,0,2.194-2.194Z",
    transform: "translate(40.962 25.795)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M194.413,190.208a1.4,1.4,0,1,0-1.385,1.385,1.4,1.4,0,0,0,1.385-1.385Z",
    transform: "translate(41.087 29.381)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 8.671,
    cy: 8.671,
    r: 8.671,
    transform: "translate(242.739)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.861,
    cy: 7.861,
    r: 7.861,
    transform: "translate(243.549 24.253)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.052,
    cy: 7.052,
    r: 7.052,
    transform: "translate(244.358 48.494)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 6.242,
    cy: 6.242,
    r: 6.242,
    transform: "translate(245.168 72.735)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M213.8,90.933a5.433,5.433,0,1,0-5.433,5.433A5.433,5.433,0,0,0,213.8,90.933Z",
    transform: "translate(43.048 11.476)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M212.879,110.8a4.635,4.635,0,1,0-4.635,4.623A4.693,4.693,0,0,0,212.879,110.8Z",
    transform: "translate(43.165 15.055)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M211.95,130.647a3.813,3.813,0,1,0-1.121,2.7,3.825,3.825,0,0,0,1.121-2.7Z",
    transform: "translate(43.285 18.636)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M211.021,150.5a3.015,3.015,0,1,0-3.015,3.016,3.015,3.015,0,0,0,3.015-3.016Z",
    transform: "translate(43.405 22.219)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M210.092,170.328a2.206,2.206,0,1,0-2.206,2.194,2.206,2.206,0,0,0,2.206-2.194Z",
    transform: "translate(43.524 25.795)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M209.163,190.208a1.385,1.385,0,1,0-.41.983,1.4,1.4,0,0,0,.41-.983Z",
    transform: "translate(43.644 29.381)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 8.671,
    cy: 8.671,
    r: 8.671,
    transform: "translate(260.081)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.861,
    cy: 7.861,
    r: 7.861,
    transform: "translate(260.891 24.253)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.052,
    cy: 7.052,
    r: 7.052,
    transform: "translate(261.7 48.494)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 6.242,
    cy: 6.242,
    r: 6.242,
    transform: "translate(262.51 72.735)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 5.433,
    cy: 5.433,
    r: 5.433,
    transform: "translate(263.319 96.988)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 4.623,
    cy: 4.623,
    r: 4.623,
    transform: "translate(264.129 121.229)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M226.717,130.643a3.8,3.8,0,1,0-1.113,2.7,3.813,3.813,0,0,0,1.113-2.7Z",
    transform: "translate(45.849 18.64)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M225.787,150.492a3,3,0,1,0-.876,2.132A3,3,0,0,0,225.787,150.492Z",
    transform: "translate(45.968 22.223)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M224.858,170.324a2.194,2.194,0,1,0-2.194,2.194A2.194,2.194,0,0,0,224.858,170.324Z",
    transform: "translate(46.088 25.798)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M223.929,190.2a1.385,1.385,0,1,0-1.385,1.385,1.385,1.385,0,0,0,1.385-1.385Z",
    transform: "translate(46.207 29.385)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 8.671,
    cy: 8.671,
    r: 8.671,
    transform: "translate(277.411)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.861,
    cy: 7.861,
    r: 7.861,
    transform: "translate(278.221 24.253)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.052,
    cy: 7.052,
    r: 7.052,
    transform: "translate(279.03 48.494)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 6.242,
    cy: 6.242,
    r: 6.242,
    transform: "translate(279.84 72.735)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 5.433,
    cy: 5.433,
    r: 5.433,
    transform: "translate(280.649 96.988)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 4.623,
    cy: 4.623,
    r: 4.623,
    transform: "translate(281.459 121.229)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 3.813,
    cy: 3.813,
    r: 3.813,
    transform: "translate(282.269 145.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M240.571,150.5a3,3,0,1,0-.876,2.132A3.015,3.015,0,0,0,240.571,150.5Z",
    transform: "translate(48.527 22.219)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M239.652,170.328a2.206,2.206,0,1,0-2.194,2.194,2.206,2.206,0,0,0,2.194-2.194Z",
    transform: "translate(48.648 25.795)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M238.713,190.208a1.4,1.4,0,1,0-1.385,1.385,1.4,1.4,0,0,0,1.385-1.385Z",
    transform: "translate(48.766 29.381)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 8.671,
    cy: 8.671,
    r: 8.671,
    transform: "translate(294.753)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.861,
    cy: 7.861,
    r: 7.861,
    transform: "translate(295.563 24.253)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.052,
    cy: 7.052,
    r: 7.052,
    transform: "translate(296.372 48.494)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 6.242,
    cy: 6.242,
    r: 6.242,
    transform: "translate(297.182 72.735)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 5.433,
    cy: 5.433,
    r: 5.433,
    transform: "translate(297.991 96.988)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 4.623,
    cy: 4.623,
    r: 4.623,
    transform: "translate(298.801 121.229)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 3.813,
    cy: 3.813,
    r: 3.813,
    transform: "translate(299.611 145.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M255.351,150.5a3.015,3.015,0,1,0-3.015,3.016,3.015,3.015,0,0,0,3.015-3.016Z",
    transform: "translate(51.088 22.219)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M254.422,170.328a2.206,2.206,0,1,0-2.206,2.194,2.206,2.206,0,0,0,2.206-2.194Z",
    transform: "translate(51.208 25.795)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M253.493,190.208a1.385,1.385,0,1,0-.41.983,1.4,1.4,0,0,0,.41-.983Z",
    transform: "translate(51.328 29.381)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 8.671,
    cy: 8.671,
    r: 8.671,
    transform: "translate(312.095)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.861,
    cy: 7.861,
    r: 7.861,
    transform: "translate(312.904 24.253)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.052,
    cy: 7.052,
    r: 7.052,
    transform: "translate(313.714 48.494)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 6.242,
    cy: 6.242,
    r: 6.242,
    transform: "translate(314.524 72.735)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 5.433,
    cy: 5.433,
    r: 5.433,
    transform: "translate(315.333 96.988)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 4.623,
    cy: 4.623,
    r: 4.623,
    transform: "translate(316.143 121.229)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 3.813,
    cy: 3.813,
    r: 3.813,
    transform: "translate(316.952 145.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M270.117,150.492a3,3,0,1,0-.876,2.132A3,3,0,0,0,270.117,150.492Z",
    transform: "translate(53.652 22.223)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M269.188,170.324a2.194,2.194,0,1,0-2.194,2.194A2.194,2.194,0,0,0,269.188,170.324Z",
    transform: "translate(53.772 25.798)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M268.272,190.208a1.4,1.4,0,1,0-1.4,1.384,1.4,1.4,0,0,0,1.4-1.384Z",
    transform: "translate(53.889 29.381)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 8.671,
    cy: 8.671,
    r: 8.671,
    transform: "translate(329.425)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.861,
    cy: 7.861,
    r: 7.861,
    transform: "translate(330.235 24.253)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.052,
    cy: 7.052,
    r: 7.052,
    transform: "translate(331.044 48.494)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 6.242,
    cy: 6.242,
    r: 6.242,
    transform: "translate(331.854 72.735)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 5.433,
    cy: 5.433,
    r: 5.433,
    transform: "translate(332.663 96.988)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 4.623,
    cy: 4.623,
    r: 4.623,
    transform: "translate(333.473 121.229)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 3.813,
    cy: 3.813,
    r: 3.813,
    transform: "translate(334.283 145.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M284.891,150.5a3,3,0,1,0-.876,2.132,3.015,3.015,0,0,0,.876-2.132Z",
    transform: "translate(56.209 22.219)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M283.972,170.328a2.206,2.206,0,1,0-2.194,2.194,2.206,2.206,0,0,0,2.194-2.194Z",
    transform: "translate(56.33 25.795)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M283.043,190.208a1.4,1.4,0,1,0-1.385,1.385A1.4,1.4,0,0,0,283.043,190.208Z",
    transform: "translate(56.45 29.381)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 8.671,
    cy: 8.671,
    r: 8.671,
    transform: "translate(346.767)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.861,
    cy: 7.861,
    r: 7.861,
    transform: "translate(347.576 24.253)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.052,
    cy: 7.052,
    r: 7.052,
    transform: "translate(348.386 48.494)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 6.242,
    cy: 6.242,
    r: 6.242,
    transform: "translate(349.196 72.735)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 5.433,
    cy: 5.433,
    r: 5.433,
    transform: "translate(350.005 96.988)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 4.623,
    cy: 4.623,
    r: 4.623,
    transform: "translate(350.815 121.229)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 3.813,
    cy: 3.813,
    r: 3.813,
    transform: "translate(351.624 145.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M299.681,150.5a3.015,3.015,0,1,0-3.015,3.016,3.015,3.015,0,0,0,3.015-3.016Z",
    transform: "translate(58.772 22.219)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M298.752,170.328a2.206,2.206,0,1,0-2.206,2.194,2.206,2.206,0,0,0,2.206-2.194Z",
    transform: "translate(58.892 25.795)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M297.823,190.208a1.385,1.385,0,1,0-.41.983A1.4,1.4,0,0,0,297.823,190.208Z",
    transform: "translate(59.011 29.381)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 8.671,
    cy: 8.671,
    r: 8.671,
    transform: "translate(364.109)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.861,
    cy: 7.861,
    r: 7.861,
    transform: "translate(364.918 24.253)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.052,
    cy: 7.052,
    r: 7.052,
    transform: "translate(365.728 48.494)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 6.242,
    cy: 6.242,
    r: 6.242,
    transform: "translate(366.537 72.735)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 5.433,
    cy: 5.433,
    r: 5.433,
    transform: "translate(367.347 96.988)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 4.623,
    cy: 4.623,
    r: 4.623,
    transform: "translate(368.157 121.229)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 3.813,
    cy: 3.813,
    r: 3.813,
    transform: "translate(368.966 145.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M314.447,150.492a3,3,0,1,0-.876,2.132,3,3,0,0,0,.876-2.132Z",
    transform: "translate(61.336 22.223)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M313.532,170.322a2.206,2.206,0,1,0-.638,1.575A2.206,2.206,0,0,0,313.532,170.322Z",
    transform: "translate(61.454 25.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M312.6,190.208a1.385,1.385,0,1,0-.41.983A1.4,1.4,0,0,0,312.6,190.208Z",
    transform: "translate(61.573 29.381)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 8.671,
    cy: 8.671,
    r: 8.671,
    transform: "translate(381.439)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.861,
    cy: 7.861,
    r: 7.861,
    transform: "translate(382.248 24.253)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.052,
    cy: 7.052,
    r: 7.052,
    transform: "translate(383.058 48.494)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 6.242,
    cy: 6.242,
    r: 6.242,
    transform: "translate(383.868 72.735)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 5.433,
    cy: 5.433,
    r: 5.433,
    transform: "translate(384.677 96.988)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 4.623,
    cy: 4.623,
    r: 4.623,
    transform: "translate(385.487 121.229)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 3.813,
    cy: 3.813,
    r: 3.813,
    transform: "translate(386.296 145.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M329.231,150.5a3,3,0,1,0-.876,2.132,3.015,3.015,0,0,0,.876-2.132Z",
    transform: "translate(63.894 22.219)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M328.3,170.328a2.206,2.206,0,1,0-2.194,2.194,2.206,2.206,0,0,0,2.194-2.194Z",
    transform: "translate(64.014 25.795)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M327.413,190.208a1.4,1.4,0,1,0-1.385,1.385A1.4,1.4,0,0,0,327.413,190.208Z",
    transform: "translate(64.14 29.381)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 8.671,
    cy: 8.671,
    r: 8.671,
    transform: "translate(398.781)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.861,
    cy: 7.861,
    r: 7.861,
    transform: "translate(399.59 24.253)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.052,
    cy: 7.052,
    r: 7.052,
    transform: "translate(400.4 48.494)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 6.242,
    cy: 6.242,
    r: 6.242,
    transform: "translate(401.209 72.735)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 5.433,
    cy: 5.433,
    r: 5.433,
    transform: "translate(402.019 96.988)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 4.623,
    cy: 4.623,
    r: 4.623,
    transform: "translate(402.829 121.229)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 3.813,
    cy: 3.813,
    r: 3.813,
    transform: "translate(403.638 145.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M344.011,150.5A3.015,3.015,0,1,0,341,153.511a3.015,3.015,0,0,0,3.015-3.016Z",
    transform: "translate(66.456 22.219)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M343.082,170.328a2.206,2.206,0,1,0-2.206,2.194,2.206,2.206,0,0,0,2.206-2.194Z",
    transform: "translate(66.576 25.795)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M342.152,190.208a1.385,1.385,0,1,0-.41.983A1.4,1.4,0,0,0,342.152,190.208Z",
    transform: "translate(66.695 29.381)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 8.671,
    cy: 8.671,
    r: 8.671,
    transform: "translate(416.122)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.861,
    cy: 7.861,
    r: 7.861,
    transform: "translate(416.932 24.253)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.052,
    cy: 7.052,
    r: 7.052,
    transform: "translate(417.742 48.494)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 6.242,
    cy: 6.242,
    r: 6.242,
    transform: "translate(418.551 72.735)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 5.433,
    cy: 5.433,
    r: 5.433,
    transform: "translate(419.361 96.988)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 4.623,
    cy: 4.623,
    r: 4.623,
    transform: "translate(420.171 121.229)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 3.813,
    cy: 3.813,
    r: 3.813,
    transform: "translate(420.98 145.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M358.777,150.492a3,3,0,1,0-.876,2.132,3,3,0,0,0,.876-2.132Z",
    transform: "translate(69.02 22.223)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M357.862,170.328a2.206,2.206,0,1,0-2.206,2.194,2.206,2.206,0,0,0,2.206-2.194Z",
    transform: "translate(69.138 25.795)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M356.932,190.208a1.385,1.385,0,1,0-.41.983,1.4,1.4,0,0,0,.41-.983Z",
    transform: "translate(69.257 29.381)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 8.671,
    cy: 8.671,
    r: 8.671,
    transform: "translate(433.453)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.861,
    cy: 7.861,
    r: 7.861,
    transform: "translate(434.262 24.253)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.052,
    cy: 7.052,
    r: 7.052,
    transform: "translate(435.072 48.494)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 6.242,
    cy: 6.242,
    r: 6.242,
    transform: "translate(435.881 72.735)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 5.433,
    cy: 5.433,
    r: 5.433,
    transform: "translate(436.691 96.988)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 4.623,
    cy: 4.623,
    r: 4.623,
    transform: "translate(437.501 121.229)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 3.813,
    cy: 3.813,
    r: 3.813,
    transform: "translate(438.31 145.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M373.561,150.5a3,3,0,1,0-.876,2.132,3.016,3.016,0,0,0,.876-2.132Z",
    transform: "translate(71.578 22.219)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M372.652,170.328a2.206,2.206,0,1,0-2.194,2.194,2.206,2.206,0,0,0,2.194-2.194Z",
    transform: "translate(71.701 25.795)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M371.7,190.208a1.4,1.4,0,1,0-1.385,1.385A1.4,1.4,0,0,0,371.7,190.208Z",
    transform: "translate(71.817 29.381)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 8.671,
    cy: 8.671,
    r: 8.671,
    transform: "translate(450.794)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.861,
    cy: 7.861,
    r: 7.861,
    transform: "translate(451.604 24.253)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.052,
    cy: 7.052,
    r: 7.052,
    transform: "translate(452.414 48.494)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 6.242,
    cy: 6.242,
    r: 6.242,
    transform: "translate(453.223 72.735)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 5.433,
    cy: 5.433,
    r: 5.433,
    transform: "translate(454.033 96.988)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 4.623,
    cy: 4.623,
    r: 4.623,
    transform: "translate(454.842 121.229)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 3.813,
    cy: 3.813,
    r: 3.813,
    transform: "translate(455.652 145.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M388.341,150.5a3.015,3.015,0,1,0-3.015,3.016,3.015,3.015,0,0,0,3.015-3.016Z",
    transform: "translate(74.14 22.219)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M387.412,170.328a2.206,2.206,0,1,0-2.206,2.194,2.206,2.206,0,0,0,2.206-2.194Z",
    transform: "translate(74.26 25.795)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M386.483,190.208a1.385,1.385,0,1,0-.41.983,1.4,1.4,0,0,0,.41-.983Z",
    transform: "translate(74.379 29.381)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 8.671,
    cy: 8.671,
    r: 8.671,
    transform: "translate(468.136)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.861,
    cy: 7.861,
    r: 7.861,
    transform: "translate(468.946 24.253)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.052,
    cy: 7.052,
    r: 7.052,
    transform: "translate(469.756 48.494)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 6.242,
    cy: 6.242,
    r: 6.242,
    transform: "translate(470.565 72.735)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 5.433,
    cy: 5.433,
    r: 5.433,
    transform: "translate(471.375 96.988)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 4.623,
    cy: 4.623,
    r: 4.623,
    transform: "translate(472.184 121.229)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 3.813,
    cy: 3.813,
    r: 3.813,
    transform: "translate(472.994 145.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M403.121,150.5a3.015,3.015,0,1,0-3.015,3.016,3.015,3.015,0,0,0,3.015-3.016Z",
    transform: "translate(76.702 22.219)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M402.192,170.328a2.206,2.206,0,1,0-2.206,2.194,2.206,2.206,0,0,0,2.206-2.194Z",
    transform: "translate(76.821 25.795)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M401.263,190.208a1.385,1.385,0,1,0-.41.983,1.4,1.4,0,0,0,.41-.983Z",
    transform: "translate(76.941 29.381)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 8.671,
    cy: 8.671,
    r: 8.671,
    transform: "translate(485.478)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.861,
    cy: 7.861,
    r: 7.861,
    transform: "translate(486.288 24.253)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.052,
    cy: 7.052,
    r: 7.052,
    transform: "translate(487.097 48.494)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 6.242,
    cy: 6.242,
    r: 6.242,
    transform: "translate(487.907 72.735)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 5.433,
    cy: 5.433,
    r: 5.433,
    transform: "translate(488.717 96.988)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 4.623,
    cy: 4.623,
    r: 4.623,
    transform: "translate(489.526 121.229)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 3.813,
    cy: 3.813,
    r: 3.813,
    transform: "translate(490.336 145.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M417.887,150.492a3,3,0,1,0-.876,2.132,3,3,0,0,0,.876-2.132Z",
    transform: "translate(79.265 22.223)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M416.962,170.328a2.206,2.206,0,1,0-2.194,2.194,2.206,2.206,0,0,0,2.194-2.194Z",
    transform: "translate(79.382 25.795)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M416.033,190.208a1.4,1.4,0,1,0-1.385,1.385,1.4,1.4,0,0,0,1.385-1.385Z",
    transform: "translate(79.501 29.381)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 8.671,
    cy: 8.671,
    r: 8.671,
    transform: "translate(502.808)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.861,
    cy: 7.861,
    r: 7.861,
    transform: "translate(503.618 24.253)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.052,
    cy: 7.052,
    r: 7.052,
    transform: "translate(504.428 48.494)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 6.242,
    cy: 6.242,
    r: 6.242,
    transform: "translate(505.237 72.735)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 5.433,
    cy: 5.433,
    r: 5.433,
    transform: "translate(506.047 96.988)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 4.623,
    cy: 4.623,
    r: 4.623,
    transform: "translate(506.856 121.229)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M433.6,130.647a3.825,3.825,0,1,0-3.813,3.813,3.825,3.825,0,0,0,3.813-3.813Z",
    transform: "translate(81.704 18.636)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M432.671,150.5a3,3,0,1,0-.876,2.132,3.015,3.015,0,0,0,.876-2.132Z",
    transform: "translate(81.824 22.219)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M431.742,170.328a2.206,2.206,0,1,0-2.194,2.194,2.206,2.206,0,0,0,2.194-2.194Z",
    transform: "translate(81.943 25.795)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M430.813,190.208a1.4,1.4,0,1,0-1.385,1.385,1.4,1.4,0,0,0,1.385-1.385Z",
    transform: "translate(82.063 29.381)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 8.671,
    cy: 8.671,
    r: 8.671,
    transform: "translate(520.15)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.861,
    cy: 7.861,
    r: 7.861,
    transform: "translate(520.96 24.253)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.052,
    cy: 7.052,
    r: 7.052,
    transform: "translate(521.769 48.494)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 6.242,
    cy: 6.242,
    r: 6.242,
    transform: "translate(522.579 72.735)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 5.433,
    cy: 5.433,
    r: 5.433,
    transform: "translate(523.389 96.988)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M449.3,110.793a4.623,4.623,0,1,0-4.623,4.623,4.623,4.623,0,0,0,4.623-4.623Z",
    transform: "translate(84.148 15.059)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M448.367,130.643a3.8,3.8,0,1,0-1.113,2.7A3.813,3.813,0,0,0,448.367,130.643Z",
    transform: "translate(84.268 18.64)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M447.451,150.5a3.015,3.015,0,1,0-3.016,3.016,3.015,3.015,0,0,0,3.016-3.016Z",
    transform: "translate(84.386 22.219)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M446.522,170.322a2.206,2.206,0,1,0-.634,1.571A2.206,2.206,0,0,0,446.522,170.322Z",
    transform: "translate(84.505 25.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M445.592,190.208a1.385,1.385,0,1,0-.41.983A1.4,1.4,0,0,0,445.592,190.208Z",
    transform: "translate(84.625 29.381)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "h",
    transform: "translate(537.492)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "i",
    cx: 8.671,
    cy: 8.671,
    r: 8.671
  }), /*#__PURE__*/React.createElement("circle", {
    className: "i",
    cx: 7.861,
    cy: 7.861,
    r: 7.861,
    transform: "translate(0.81 24.253)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "i",
    cx: 7.052,
    cy: 7.052,
    r: 7.052,
    transform: "translate(1.619 48.494)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M465.934,71.082a6.242,6.242,0,1,0-6.242,6.242A6.242,6.242,0,0,0,465.934,71.082Z",
    transform: "translate(-451.021 7.895)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M465.005,90.933a5.433,5.433,0,1,0-5.433,5.433A5.433,5.433,0,0,0,465.005,90.933Z",
    transform: "translate(-450.902 11.476)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M464.076,110.793a4.623,4.623,0,1,0-4.623,4.623,4.623,4.623,0,0,0,4.623-4.623Z",
    transform: "translate(-450.782 15.059)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M463.127,130.643a3.8,3.8,0,1,0-1.113,2.7,3.813,3.813,0,0,0,1.113-2.7Z",
    transform: "translate(-450.666 18.64)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M462.217,150.492a3,3,0,1,0-.876,2.132,3,3,0,0,0,.876-2.132Z",
    transform: "translate(-450.543 22.223)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M461.292,170.328a2.206,2.206,0,1,0-2.194,2.194,2.206,2.206,0,0,0,2.194-2.194Z",
    transform: "translate(-450.427 25.795)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M460.413,190.208a1.4,1.4,0,1,0-1.385,1.385,1.4,1.4,0,0,0,1.385-1.385Z",
    transform: "translate(-450.298 29.381)"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 8.671,
    cy: 8.671,
    r: 8.671,
    transform: "translate(554.822)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.861,
    cy: 7.861,
    r: 7.861,
    transform: "translate(555.632 24.253)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M481.64,51.23a7.04,7.04,0,1,0-7.04,7.04A7.04,7.04,0,0,0,481.64,51.23Z",
    transform: "translate(88.917 4.316)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M480.714,71.082a6.242,6.242,0,1,0-6.242,6.242A6.242,6.242,0,0,0,480.714,71.082Z",
    transform: "translate(89.033 7.895)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M479.789,90.936a5.444,5.444,0,1,0-5.433,5.433,5.444,5.444,0,0,0,5.433-5.433Z",
    transform: "translate(89.149 11.472)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M478.859,110.8a4.635,4.635,0,1,0-4.623,4.623A4.635,4.635,0,0,0,478.859,110.8Z",
    transform: "translate(89.268 15.055)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M477.93,130.647a3.825,3.825,0,1,0-3.813,3.813,3.825,3.825,0,0,0,3.813-3.813Z",
    transform: "translate(89.388 18.636)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M477,150.5a3,3,0,1,0-.876,2.132A3.015,3.015,0,0,0,477,150.5Z",
    transform: "translate(89.508 22.219)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M476.072,170.328a2.206,2.206,0,1,0-2.194,2.194,2.206,2.206,0,0,0,2.194-2.194Z",
    transform: "translate(89.627 25.795)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M475.143,190.208a1.4,1.4,0,1,0-1.385,1.385A1.4,1.4,0,0,0,475.143,190.208Z",
    transform: "translate(89.747 29.381)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 8.671,
    cy: 8.671,
    r: 8.671,
    transform: "translate(572.164)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.861,
    cy: 7.861,
    r: 7.861,
    transform: "translate(572.974 24.253)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M496.41,51.23a7.04,7.04,0,1,0-7.04,7.04A7.04,7.04,0,0,0,496.41,51.23Z",
    transform: "translate(91.477 4.316)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M495.484,71.082a6.242,6.242,0,1,0-6.242,6.242A6.242,6.242,0,0,0,495.484,71.082Z",
    transform: "translate(91.593 7.895)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M494.605,90.933a5.433,5.433,0,1,0-5.432,5.433A5.433,5.433,0,0,0,494.605,90.933Z",
    transform: "translate(91.721 11.476)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M493.626,110.793A4.623,4.623,0,1,0,489,115.416a4.623,4.623,0,0,0,4.623-4.623Z",
    transform: "translate(91.832 15.059)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M492.71,130.647a3.813,3.813,0,1,0-1.121,2.7,3.825,3.825,0,0,0,1.121-2.7Z",
    transform: "translate(91.95 18.636)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M491.781,150.5a3.015,3.015,0,1,0-3.015,3.016,3.015,3.015,0,0,0,3.015-3.016Z",
    transform: "translate(92.07 22.219)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M490.852,170.328a2.206,2.206,0,1,0-2.206,2.194,2.206,2.206,0,0,0,2.206-2.194Z",
    transform: "translate(92.189 25.795)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M489.923,190.208a1.385,1.385,0,1,0-.41.983A1.4,1.4,0,0,0,489.923,190.208Z",
    transform: "translate(92.309 29.381)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 8.671,
    cy: 8.671,
    r: 8.671,
    transform: "translate(589.506)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.861,
    cy: 7.861,
    r: 7.861,
    transform: "translate(590.315 24.253)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.052,
    cy: 7.052,
    r: 7.052,
    transform: "translate(591.125 48.494)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M510.264,71.082a6.242,6.242,0,1,0-6.242,6.242A6.242,6.242,0,0,0,510.264,71.082Z",
    transform: "translate(94.155 7.895)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M509.335,90.933a5.433,5.433,0,1,0-5.432,5.433,5.432,5.432,0,0,0,5.432-5.433Z",
    transform: "translate(94.274 11.476)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M508.366,110.793a4.623,4.623,0,1,0-4.623,4.623,4.623,4.623,0,0,0,4.623-4.623Z",
    transform: "translate(94.387 15.059)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M507.477,130.643a3.8,3.8,0,1,0-1.113,2.7,3.813,3.813,0,0,0,1.113-2.7Z",
    transform: "translate(94.514 18.64)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M506.547,150.492a3,3,0,1,0-.876,2.132,3,3,0,0,0,.876-2.132Z",
    transform: "translate(94.633 22.223)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M505.648,170.324a2.194,2.194,0,1,0-2.194,2.194,2.194,2.194,0,0,0,2.194-2.194Z",
    transform: "translate(94.758 25.798)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M504.693,190.208a1.4,1.4,0,1,0-1.385,1.385A1.4,1.4,0,0,0,504.693,190.208Z",
    transform: "translate(94.869 29.381)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 8.671,
    cy: 8.671,
    r: 8.671,
    transform: "translate(606.836)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.861,
    cy: 7.861,
    r: 7.861,
    transform: "translate(607.646 24.253)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.052,
    cy: 7.052,
    r: 7.052,
    transform: "translate(608.455 48.494)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 6.242,
    cy: 6.242,
    r: 6.242,
    transform: "translate(609.265 72.735)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M524.119,90.936a5.444,5.444,0,1,0-5.432,5.433,5.444,5.444,0,0,0,5.432-5.433Z",
    transform: "translate(96.833 11.472)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M523.189,110.8a4.635,4.635,0,1,0-4.623,4.623,4.634,4.634,0,0,0,4.623-4.623Z",
    transform: "translate(96.952 15.055)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M522.26,130.647a3.825,3.825,0,1,0-3.813,3.813A3.825,3.825,0,0,0,522.26,130.647Z",
    transform: "translate(97.072 18.636)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M521.331,150.5a3,3,0,1,0-.876,2.132A3.016,3.016,0,0,0,521.331,150.5Z",
    transform: "translate(97.191 22.219)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M520.4,170.328a2.206,2.206,0,1,0-2.194,2.194,2.206,2.206,0,0,0,2.194-2.194Z",
    transform: "translate(97.311 25.795)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M519.473,190.208a1.4,1.4,0,1,0-1.384,1.385,1.4,1.4,0,0,0,1.384-1.385Z",
    transform: "translate(97.431 29.381)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 8.671,
    cy: 8.671,
    r: 8.671,
    transform: "translate(624.178)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.861,
    cy: 7.861,
    r: 7.861,
    transform: "translate(624.987 24.253)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.052,
    cy: 7.052,
    r: 7.052,
    transform: "translate(625.797 48.494)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 6.242,
    cy: 6.242,
    r: 6.242,
    transform: "translate(626.607 72.735)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 5.433,
    cy: 5.433,
    r: 5.433,
    transform: "translate(627.416 96.988)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M537.956,110.793a4.623,4.623,0,1,0-4.623,4.623,4.623,4.623,0,0,0,4.623-4.623Z",
    transform: "translate(99.516 15.059)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M537.04,130.647a3.813,3.813,0,1,0-1.121,2.7,3.825,3.825,0,0,0,1.121-2.7Z",
    transform: "translate(99.634 18.636)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M536.111,150.5a3.015,3.015,0,1,0-3.015,3.016,3.015,3.015,0,0,0,3.015-3.016Z",
    transform: "translate(99.753 22.219)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M535.182,170.328a2.206,2.206,0,1,0-2.206,2.194,2.206,2.206,0,0,0,2.206-2.194Z",
    transform: "translate(99.873 25.795)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M534.253,190.208a1.385,1.385,0,1,0-.41.983A1.4,1.4,0,0,0,534.253,190.208Z",
    transform: "translate(99.993 29.381)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 8.671,
    cy: 8.671,
    r: 8.671,
    transform: "translate(641.52)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.861,
    cy: 7.861,
    r: 7.861,
    transform: "translate(642.329 24.253)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.052,
    cy: 7.052,
    r: 7.052,
    transform: "translate(643.139 48.494)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 6.242,
    cy: 6.242,
    r: 6.242,
    transform: "translate(643.949 72.735)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 5.433,
    cy: 5.433,
    r: 5.433,
    transform: "translate(644.758 96.988)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 4.623,
    cy: 4.623,
    r: 4.623,
    transform: "translate(645.568 121.229)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 3.813,
    cy: 3.813,
    r: 3.813,
    transform: "translate(646.377 145.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M550.887,150.492a3,3,0,1,0-.876,2.131A3,3,0,0,0,550.887,150.492Z",
    transform: "translate(102.319 22.223)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M549.948,170.324a2.194,2.194,0,1,0-2.194,2.194,2.194,2.194,0,0,0,2.194-2.194Z",
    transform: "translate(102.437 25.798)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M549.022,190.208a1.4,1.4,0,1,0-1.385,1.385A1.4,1.4,0,0,0,549.022,190.208Z",
    transform: "translate(102.553 29.381)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 8.671,
    cy: 8.671,
    r: 8.671,
    transform: "translate(658.85)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.861,
    cy: 7.861,
    r: 7.861,
    transform: "translate(659.659 24.253)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.052,
    cy: 7.052,
    r: 7.052,
    transform: "translate(660.469 48.494)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 6.242,
    cy: 6.242,
    r: 6.242,
    transform: "translate(661.279 72.735)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 5.433,
    cy: 5.433,
    r: 5.433,
    transform: "translate(662.088 96.988)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 4.623,
    cy: 4.623,
    r: 4.623,
    transform: "translate(662.898 121.229)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 3.813,
    cy: 3.813,
    r: 3.813,
    transform: "translate(663.708 145.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M565.661,150.5a3,3,0,1,0-.876,2.132,3.016,3.016,0,0,0,.876-2.132Z",
    transform: "translate(104.875 22.219)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M564.732,170.328a2.206,2.206,0,1,0-2.194,2.194,2.206,2.206,0,0,0,2.194-2.194Z",
    transform: "translate(104.995 25.795)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M563.8,190.208a1.4,1.4,0,1,0-1.385,1.385A1.4,1.4,0,0,0,563.8,190.208Z",
    transform: "translate(105.115 29.381)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 8.671,
    cy: 8.671,
    r: 8.671,
    transform: "translate(676.192)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.861,
    cy: 7.861,
    r: 7.861,
    transform: "translate(677.001 24.253)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.052,
    cy: 7.052,
    r: 7.052,
    transform: "translate(677.811 48.494)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 6.242,
    cy: 6.242,
    r: 6.242,
    transform: "translate(678.621 72.735)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 5.433,
    cy: 5.433,
    r: 5.433,
    transform: "translate(679.43 96.988)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 4.623,
    cy: 4.623,
    r: 4.623,
    transform: "translate(680.24 121.229)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 3.813,
    cy: 3.813,
    r: 3.813,
    transform: "translate(681.049 145.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M580.441,150.5a3.015,3.015,0,1,0-3.015,3.016,3.015,3.015,0,0,0,3.015-3.016Z",
    transform: "translate(107.437 22.219)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M579.512,170.322a2.206,2.206,0,1,0-2.182,2.229,2.206,2.206,0,0,0,2.182-2.229Z",
    transform: "translate(107.557 25.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M578.583,190.208a1.385,1.385,0,1,0-.41.983A1.4,1.4,0,0,0,578.583,190.208Z",
    transform: "translate(107.676 29.381)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 8.671,
    cy: 8.671,
    r: 8.671,
    transform: "translate(693.534)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.861,
    cy: 7.861,
    r: 7.861,
    transform: "translate(694.343 24.253)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.052,
    cy: 7.052,
    r: 7.052,
    transform: "translate(695.153 48.494)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 6.242,
    cy: 6.242,
    r: 6.242,
    transform: "translate(695.962 72.735)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 5.433,
    cy: 5.433,
    r: 5.433,
    transform: "translate(696.772 96.988)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 4.623,
    cy: 4.623,
    r: 4.623,
    transform: "translate(697.582 121.229)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 3.813,
    cy: 3.813,
    r: 3.813,
    transform: "translate(698.391 145.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M595.207,150.492a3,3,0,1,0-.876,2.132A3,3,0,0,0,595.207,150.492Z",
    transform: "translate(110.001 22.223)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M594.278,170.324a2.194,2.194,0,1,0-2.194,2.194A2.194,2.194,0,0,0,594.278,170.324Z",
    transform: "translate(110.12 25.798)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M593.349,190.2a1.385,1.385,0,1,0-1.385,1.385A1.385,1.385,0,0,0,593.349,190.2Z",
    transform: "translate(110.24 29.385)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 8.671,
    cy: 8.671,
    r: 8.671,
    transform: "translate(710.864)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.861,
    cy: 7.861,
    r: 7.861,
    transform: "translate(711.673 24.253)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.052,
    cy: 7.052,
    r: 7.052,
    transform: "translate(712.483 48.494)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 6.242,
    cy: 6.242,
    r: 6.242,
    transform: "translate(713.292 72.735)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 5.433,
    cy: 5.433,
    r: 5.433,
    transform: "translate(714.102 96.988)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 4.623,
    cy: 4.623,
    r: 4.623,
    transform: "translate(714.912 121.229)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 3.813,
    cy: 3.813,
    r: 3.813,
    transform: "translate(715.721 145.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M609.991,150.5a3,3,0,1,0-.876,2.132A3.016,3.016,0,0,0,609.991,150.5Z",
    transform: "translate(112.559 22.219)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M609.062,170.328a2.206,2.206,0,1,0-2.194,2.194,2.206,2.206,0,0,0,2.194-2.194Z",
    transform: "translate(112.679 25.795)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M608.132,190.208a1.4,1.4,0,1,0-1.385,1.385A1.4,1.4,0,0,0,608.132,190.208Z",
    transform: "translate(112.799 29.381)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 8.671,
    cy: 8.671,
    r: 8.671,
    transform: "translate(728.206)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.861,
    cy: 7.861,
    r: 7.861,
    transform: "translate(729.015 24.253)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.052,
    cy: 7.052,
    r: 7.052,
    transform: "translate(729.825 48.494)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 6.242,
    cy: 6.242,
    r: 6.242,
    transform: "translate(730.634 72.735)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 5.433,
    cy: 5.433,
    r: 5.433,
    transform: "translate(731.444 96.988)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 4.623,
    cy: 4.623,
    r: 4.623,
    transform: "translate(732.254 121.229)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 3.813,
    cy: 3.813,
    r: 3.813,
    transform: "translate(733.063 145.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M624.771,150.5a3.015,3.015,0,1,0-3.015,3.016,3.015,3.015,0,0,0,3.015-3.016Z",
    transform: "translate(115.121 22.219)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M623.842,170.328a2.206,2.206,0,1,0-2.206,2.194,2.206,2.206,0,0,0,2.206-2.194Z",
    transform: "translate(115.241 25.795)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M622.912,190.208a1.385,1.385,0,1,0-.41.983,1.4,1.4,0,0,0,.41-.983Z",
    transform: "translate(115.36 29.381)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 8.671,
    cy: 8.671,
    r: 8.671,
    transform: "translate(745.547)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.861,
    cy: 7.861,
    r: 7.861,
    transform: "translate(746.357 24.253)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.052,
    cy: 7.052,
    r: 7.052,
    transform: "translate(747.167 48.494)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 6.242,
    cy: 6.242,
    r: 6.242,
    transform: "translate(747.976 72.735)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 5.433,
    cy: 5.433,
    r: 5.433,
    transform: "translate(748.786 96.988)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 4.623,
    cy: 4.623,
    r: 4.623,
    transform: "translate(749.595 121.229)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 3.813,
    cy: 3.813,
    r: 3.813,
    transform: "translate(750.405 145.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M639.537,150.492a3,3,0,1,0-.876,2.132A3,3,0,0,0,639.537,150.492Z",
    transform: "translate(117.685 22.223)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M638.648,170.324a2.194,2.194,0,1,0-2.194,2.194,2.194,2.194,0,0,0,2.194-2.194Z",
    transform: "translate(117.811 25.798)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M637.693,190.208a1.4,1.4,0,1,0-1.4,1.384,1.4,1.4,0,0,0,1.4-1.384Z",
    transform: "translate(117.922 29.381)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 8.671,
    cy: 8.671,
    r: 8.671,
    transform: "translate(762.878)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.861,
    cy: 7.861,
    r: 7.861,
    transform: "translate(763.687 24.253)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.052,
    cy: 7.052,
    r: 7.052,
    transform: "translate(764.497 48.494)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 6.242,
    cy: 6.242,
    r: 6.242,
    transform: "translate(765.306 72.735)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 5.433,
    cy: 5.433,
    r: 5.433,
    transform: "translate(766.116 96.988)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 4.623,
    cy: 4.623,
    r: 4.623,
    transform: "translate(766.926 121.229)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 3.813,
    cy: 3.813,
    r: 3.813,
    transform: "translate(767.735 145.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M654.321,150.5a3,3,0,1,0-.876,2.132A3.015,3.015,0,0,0,654.321,150.5Z",
    transform: "translate(120.243 22.219)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M653.392,170.328a2.206,2.206,0,1,0-2.194,2.194,2.206,2.206,0,0,0,2.194-2.194Z",
    transform: "translate(120.363 25.795)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M652.463,190.208a1.4,1.4,0,1,0-1.385,1.385,1.4,1.4,0,0,0,1.385-1.385Z",
    transform: "translate(120.482 29.381)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 8.671,
    cy: 8.671,
    r: 8.671,
    transform: "translate(780.219)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.861,
    cy: 7.861,
    r: 7.861,
    transform: "translate(781.029 24.253)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.052,
    cy: 7.052,
    r: 7.052,
    transform: "translate(781.839 48.494)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 6.242,
    cy: 6.242,
    r: 6.242,
    transform: "translate(782.648 72.735)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 5.433,
    cy: 5.433,
    r: 5.433,
    transform: "translate(783.458 96.988)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 4.623,
    cy: 4.623,
    r: 4.623,
    transform: "translate(784.267 121.229)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 3.813,
    cy: 3.813,
    r: 3.813,
    transform: "translate(785.077 145.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M669.1,150.5a3.015,3.015,0,1,0-3.015,3.016A3.015,3.015,0,0,0,669.1,150.5Z",
    transform: "translate(122.805 22.219)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M668.172,170.328a2.206,2.206,0,1,0-2.206,2.194,2.206,2.206,0,0,0,2.206-2.194Z",
    transform: "translate(122.924 25.795)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M667.242,190.208a1.385,1.385,0,1,0-.41.983,1.4,1.4,0,0,0,.41-.983Z",
    transform: "translate(123.044 29.381)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 8.671,
    cy: 8.671,
    r: 8.671,
    transform: "translate(797.561)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.861,
    cy: 7.861,
    r: 7.861,
    transform: "translate(798.371 24.253)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.052,
    cy: 7.052,
    r: 7.052,
    transform: "translate(799.18 48.494)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 6.242,
    cy: 6.242,
    r: 6.242,
    transform: "translate(799.99 72.735)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 5.433,
    cy: 5.433,
    r: 5.433,
    transform: "translate(800.8 96.988)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 4.623,
    cy: 4.623,
    r: 4.623,
    transform: "translate(801.609 121.229)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 3.813,
    cy: 3.813,
    r: 3.813,
    transform: "translate(802.419 145.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M683.887,150.492a3,3,0,1,0-.876,2.132A3,3,0,0,0,683.887,150.492Z",
    transform: "translate(125.372 22.223)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M682.938,170.324a2.194,2.194,0,1,0-2.194,2.194,2.194,2.194,0,0,0,2.194-2.194Z",
    transform: "translate(125.488 25.798)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M682.022,190.208a1.385,1.385,0,1,0-.41.983A1.4,1.4,0,0,0,682.022,190.208Z",
    transform: "translate(125.606 29.381)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 8.671,
    cy: 8.671,
    r: 8.671,
    transform: "translate(814.891)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.861,
    cy: 7.861,
    r: 7.861,
    transform: "translate(815.701 24.253)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.052,
    cy: 7.052,
    r: 7.052,
    transform: "translate(816.511 48.494)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 6.242,
    cy: 6.242,
    r: 6.242,
    transform: "translate(817.32 72.735)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 5.433,
    cy: 5.433,
    r: 5.433,
    transform: "translate(818.13 96.988)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 4.623,
    cy: 4.623,
    r: 4.623,
    transform: "translate(818.939 121.229)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 3.813,
    cy: 3.813,
    r: 3.813,
    transform: "translate(819.749 145.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M698.651,150.5a3,3,0,1,0-.876,2.132A3.015,3.015,0,0,0,698.651,150.5Z",
    transform: "translate(127.927 22.219)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M697.722,170.328a2.206,2.206,0,1,0-2.194,2.194,2.206,2.206,0,0,0,2.194-2.194Z",
    transform: "translate(128.046 25.795)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M696.792,190.208a1.4,1.4,0,1,0-1.385,1.385A1.4,1.4,0,0,0,696.792,190.208Z",
    transform: "translate(128.166 29.381)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 8.671,
    cy: 8.671,
    r: 8.671,
    transform: "translate(832.233)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.861,
    cy: 7.861,
    r: 7.861,
    transform: "translate(833.043 24.253)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.052,
    cy: 7.052,
    r: 7.052,
    transform: "translate(833.852 48.494)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 6.242,
    cy: 6.242,
    r: 6.242,
    transform: "translate(834.662 72.735)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 5.433,
    cy: 5.433,
    r: 5.433,
    transform: "translate(835.472 96.988)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 4.623,
    cy: 4.623,
    r: 4.623,
    transform: "translate(836.281 121.229)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 3.813,
    cy: 3.813,
    r: 3.813,
    transform: "translate(837.091 145.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M713.431,150.5a3.015,3.015,0,1,0-3.015,3.016,3.015,3.015,0,0,0,3.015-3.016Z",
    transform: "translate(130.489 22.219)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M712.5,170.322a2.206,2.206,0,1,0-2.171,2.229A2.206,2.206,0,0,0,712.5,170.322Z",
    transform: "translate(130.608 25.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M711.572,190.208a1.385,1.385,0,1,0-.41.983A1.4,1.4,0,0,0,711.572,190.208Z",
    transform: "translate(130.728 29.381)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 8.671,
    cy: 8.671,
    r: 8.671,
    transform: "translate(849.575)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.861,
    cy: 7.861,
    r: 7.861,
    transform: "translate(850.385 24.253)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.052,
    cy: 7.052,
    r: 7.052,
    transform: "translate(851.194 48.494)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 6.242,
    cy: 6.242,
    r: 6.242,
    transform: "translate(852.004 72.735)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 5.433,
    cy: 5.433,
    r: 5.433,
    transform: "translate(852.814 96.988)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 4.623,
    cy: 4.623,
    r: 4.623,
    transform: "translate(853.623 121.229)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 3.813,
    cy: 3.813,
    r: 3.813,
    transform: "translate(854.433 145.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M728.2,150.492a3,3,0,1,0-.876,2.132A3,3,0,0,0,728.2,150.492Z",
    transform: "translate(133.052 22.223)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M727.282,170.328a2.206,2.206,0,1,0-2.206,2.194,2.206,2.206,0,0,0,2.206-2.194Z",
    transform: "translate(133.17 25.795)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M726.352,190.208a1.384,1.384,0,1,0-.41.983,1.4,1.4,0,0,0,.41-.983Z",
    transform: "translate(133.29 29.381)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 8.671,
    cy: 8.671,
    r: 8.671,
    transform: "translate(866.905)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.861,
    cy: 7.861,
    r: 7.861,
    transform: "translate(867.715 24.253)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.052,
    cy: 7.052,
    r: 7.052,
    transform: "translate(868.524 48.494)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 6.242,
    cy: 6.242,
    r: 6.242,
    transform: "translate(869.334 72.735)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 5.433,
    cy: 5.433,
    r: 5.433,
    transform: "translate(870.144 96.988)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 4.623,
    cy: 4.623,
    r: 4.623,
    transform: "translate(870.953 121.229)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M743.907,130.643a3.813,3.813,0,1,0-3.813,3.813,3.813,3.813,0,0,0,3.813-3.813Z",
    transform: "translate(135.495 18.64)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M742.981,150.5a3,3,0,1,0-.876,2.132,3.015,3.015,0,0,0,.876-2.132Z",
    transform: "translate(135.611 22.219)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M742.052,170.328a2.206,2.206,0,1,0-2.194,2.194,2.206,2.206,0,0,0,2.194-2.194Z",
    transform: "translate(135.73 25.795)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M741.122,190.208a1.4,1.4,0,1,0-1.385,1.385A1.4,1.4,0,0,0,741.122,190.208Z",
    transform: "translate(135.85 29.381)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 8.671,
    cy: 8.671,
    r: 8.671,
    transform: "translate(884.247)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.861,
    cy: 7.861,
    r: 7.861,
    transform: "translate(885.057 24.253)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.052,
    cy: 7.052,
    r: 7.052,
    transform: "translate(885.866 48.494)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 6.242,
    cy: 6.242,
    r: 6.242,
    transform: "translate(886.676 72.735)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 5.433,
    cy: 5.433,
    r: 5.433,
    transform: "translate(887.486 96.988)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M759.619,110.8a4.635,4.635,0,1,0-4.693,4.623,4.694,4.694,0,0,0,4.693-4.623Z",
    transform: "translate(137.933 15.055)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M758.69,130.647a3.813,3.813,0,1,0-1.121,2.7,3.825,3.825,0,0,0,1.121-2.7Z",
    transform: "translate(138.053 18.636)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M757.761,150.5a3.015,3.015,0,1,0-3.016,3.016,3.015,3.015,0,0,0,3.016-3.016Z",
    transform: "translate(138.173 22.219)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M756.832,170.328a2.206,2.206,0,1,0-2.206,2.194,2.206,2.206,0,0,0,2.206-2.194Z",
    transform: "translate(138.292 25.795)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M755.9,190.208a1.384,1.384,0,1,0-.41.983,1.4,1.4,0,0,0,.41-.983Z",
    transform: "translate(138.412 29.381)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M-51.272,169.414a2.464,2.464,0,0,1-2.464,2.464,2.464,2.464,0,0,1-2.464-2.464,2.464,2.464,0,0,1,2.464-2.464,2.464,2.464,0,0,1,2.464,2.464Z",
    transform: "translate(-9.741 28.938)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M-33.412,169.414a2.464,2.464,0,0,1-2.464,2.464,2.464,2.464,0,0,1-2.464-2.464,2.464,2.464,0,0,1,2.464-2.464,2.464,2.464,0,0,1,2.464,2.464Z",
    transform: "translate(-6.646 28.938)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M-15.542,169.414a2.464,2.464,0,0,1-2.464,2.464,2.464,2.464,0,0,1-2.464-2.464,2.464,2.464,0,0,1,2.464-2.464,2.464,2.464,0,0,1,2.464,2.464Z",
    transform: "translate(-3.548 28.938)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "i",
    cx: 2.464,
    cy: 2.464,
    r: 2.464,
    transform: "translate(-3.051 195.9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M20.2,169.414a2.464,2.464,0,1,1-2.464-2.464,2.464,2.464,0,0,1,2.464,2.464Z",
    transform: "translate(2.647 28.938)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M38.068,169.414A2.464,2.464,0,1,1,35.6,166.95a2.464,2.464,0,0,1,2.464,2.464Z",
    transform: "translate(5.744 28.938)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M55.938,169.414a2.464,2.464,0,1,1-2.452-2.464A2.464,2.464,0,0,1,55.938,169.414Z",
    transform: "translate(8.842 28.938)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "i",
    cx: 2.464,
    cy: 2.464,
    r: 2.464,
    transform: "translate(80.819 195.9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M91.728,169.414a2.464,2.464,0,1,1-2.464-2.464A2.464,2.464,0,0,1,91.728,169.414Z",
    transform: "translate(15.045 28.938)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M-51.272,184.272a2.464,2.464,0,0,1-2.464,2.464,2.464,2.464,0,0,1-2.464-2.464,2.452,2.452,0,0,1,.722-1.738,2.452,2.452,0,0,1,1.742-.714,2.452,2.452,0,0,1,1.742.714A2.452,2.452,0,0,1-51.272,184.272Z",
    transform: "translate(-9.741 31.515)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M-33.412,184.272a2.464,2.464,0,0,1-2.464,2.464,2.464,2.464,0,0,1-2.464-2.464,2.452,2.452,0,0,1,.722-1.738,2.452,2.452,0,0,1,1.742-.714,2.452,2.452,0,0,1,1.742.714A2.452,2.452,0,0,1-33.412,184.272Z",
    transform: "translate(-6.646 31.515)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M-15.542,184.272a2.464,2.464,0,0,1-2.464,2.464,2.464,2.464,0,0,1-2.464-2.464,2.452,2.452,0,0,1,.722-1.738,2.452,2.452,0,0,1,1.742-.714,2.452,2.452,0,0,1,1.742.714,2.452,2.452,0,0,1,.722,1.738Z",
    transform: "translate(-3.548 31.515)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M2.328,184.274a2.464,2.464,0,0,1-2.464,2.452A2.464,2.464,0,0,1-2.6,184.262a2.452,2.452,0,0,1,.722-1.738,2.452,2.452,0,0,1,1.742-.714,2.452,2.452,0,0,1,1.746.718,2.452,2.452,0,0,1,.718,1.746Z",
    transform: "translate(-0.451 31.514)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M20.2,184.272a2.464,2.464,0,1,1-2.464-2.452,2.464,2.464,0,0,1,2.464,2.452Z",
    transform: "translate(2.647 31.515)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M38.068,184.272A2.464,2.464,0,1,1,35.6,181.82a2.464,2.464,0,0,1,2.464,2.452Z",
    transform: "translate(5.744 31.515)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M55.938,184.272a2.464,2.464,0,1,1-2.452-2.452A2.464,2.464,0,0,1,55.938,184.272Z",
    transform: "translate(8.842 31.515)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M73.818,184.272a2.464,2.464,0,1,1-2.464-2.452,2.464,2.464,0,0,1,2.464,2.452Z",
    transform: "translate(11.941 31.515)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M91.728,184.272a2.464,2.464,0,1,1-2.464-2.452,2.464,2.464,0,0,1,2.464,2.452Z",
    transform: "translate(15.045 31.515)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M-51.272,199.132a2.464,2.464,0,0,1-2.464,2.464,2.464,2.464,0,0,1-2.464-2.464,2.464,2.464,0,0,1,2.464-2.452,2.464,2.464,0,0,1,2.464,2.452Z",
    transform: "translate(-9.741 34.091)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M-33.412,199.132a2.464,2.464,0,0,1-2.464,2.464,2.464,2.464,0,0,1-2.464-2.464,2.464,2.464,0,0,1,2.464-2.452,2.464,2.464,0,0,1,2.464,2.452Z",
    transform: "translate(-6.646 34.091)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M-15.542,199.132a2.464,2.464,0,0,1-2.464,2.464,2.464,2.464,0,0,1-2.464-2.464,2.464,2.464,0,0,1,2.464-2.452,2.464,2.464,0,0,1,2.464,2.452Z",
    transform: "translate(-3.548 34.091)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M2.328,199.132A2.464,2.464,0,0,1-.136,201.6,2.464,2.464,0,0,1-2.6,199.132,2.464,2.464,0,0,1-.136,196.68a2.464,2.464,0,0,1,2.464,2.452Z",
    transform: "translate(-0.451 34.091)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M20.2,199.132a2.464,2.464,0,1,1-2.464-2.452,2.464,2.464,0,0,1,2.464,2.452Z",
    transform: "translate(2.647 34.091)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M38.068,199.132A2.464,2.464,0,1,1,35.6,196.68a2.464,2.464,0,0,1,2.464,2.452Z",
    transform: "translate(5.744 34.091)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M55.938,199.132a2.464,2.464,0,1,1-2.452-2.452A2.464,2.464,0,0,1,55.938,199.132Z",
    transform: "translate(8.842 34.091)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M73.818,199.132a2.464,2.464,0,1,1-2.464-2.452,2.464,2.464,0,0,1,2.464,2.452Z",
    transform: "translate(11.941 34.091)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M91.728,199.132a2.464,2.464,0,1,1-2.464-2.452,2.464,2.464,0,0,1,2.464,2.452Z",
    transform: "translate(15.045 34.091)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M-51.272,214a2.464,2.464,0,0,1-2.464,2.452A2.464,2.464,0,0,1-56.2,214a2.464,2.464,0,0,1,2.464-2.464A2.464,2.464,0,0,1-51.272,214Z",
    transform: "translate(-9.741 36.667)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M-33.412,214a2.464,2.464,0,0,1-2.464,2.452A2.464,2.464,0,0,1-38.34,214a2.464,2.464,0,0,1,2.464-2.464A2.464,2.464,0,0,1-33.412,214Z",
    transform: "translate(-6.646 36.667)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M-15.542,214a2.464,2.464,0,0,1-2.464,2.452A2.464,2.464,0,0,1-20.47,214a2.464,2.464,0,0,1,2.464-2.464A2.464,2.464,0,0,1-15.542,214Z",
    transform: "translate(-3.548 36.667)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M2.328,214a2.464,2.464,0,0,1-2.464,2.452A2.464,2.464,0,0,1-2.6,214,2.464,2.464,0,0,1-.136,211.54,2.464,2.464,0,0,1,2.328,214Z",
    transform: "translate(-0.451 36.667)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M20.2,214a2.464,2.464,0,1,1-2.464-2.464A2.464,2.464,0,0,1,20.2,214Z",
    transform: "translate(2.647 36.667)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M38.068,214A2.464,2.464,0,1,1,35.6,211.54,2.464,2.464,0,0,1,38.068,214Z",
    transform: "translate(5.744 36.667)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M55.938,214a2.464,2.464,0,1,1-2.452-2.464A2.464,2.464,0,0,1,55.938,214Z",
    transform: "translate(8.842 36.667)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M73.818,214a2.464,2.464,0,1,1-2.464-2.464A2.464,2.464,0,0,1,73.818,214Z",
    transform: "translate(11.941 36.667)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M91.728,214a2.464,2.464,0,1,1-2.464-2.464A2.464,2.464,0,0,1,91.728,214Z",
    transform: "translate(15.045 36.667)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M-51.272,228.864a2.464,2.464,0,0,1-2.464,2.452,2.464,2.464,0,0,1-2.464-2.452,2.464,2.464,0,0,1,2.464-2.464A2.464,2.464,0,0,1-51.272,228.864Z",
    transform: "translate(-9.741 39.243)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M-33.412,228.864a2.464,2.464,0,0,1-2.464,2.452,2.464,2.464,0,0,1-2.464-2.452,2.464,2.464,0,0,1,2.464-2.464A2.464,2.464,0,0,1-33.412,228.864Z",
    transform: "translate(-6.646 39.243)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M-15.542,228.864a2.464,2.464,0,0,1-2.464,2.452,2.464,2.464,0,0,1-2.464-2.452,2.464,2.464,0,0,1,2.464-2.464A2.464,2.464,0,0,1-15.542,228.864Z",
    transform: "translate(-3.548 39.243)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M2.328,228.864a2.464,2.464,0,0,1-2.464,2.452A2.464,2.464,0,0,1-2.6,228.864,2.464,2.464,0,0,1-.136,226.4a2.464,2.464,0,0,1,2.464,2.464Z",
    transform: "translate(-0.451 39.243)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M20.2,228.864a2.464,2.464,0,1,1-2.464-2.464,2.464,2.464,0,0,1,2.464,2.464Z",
    transform: "translate(2.647 39.243)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M38.068,228.864A2.464,2.464,0,1,1,35.6,226.4a2.464,2.464,0,0,1,2.464,2.464Z",
    transform: "translate(5.744 39.243)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M55.938,228.864a2.464,2.464,0,1,1-2.452-2.464A2.464,2.464,0,0,1,55.938,228.864Z",
    transform: "translate(8.842 39.243)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M73.818,228.864a2.464,2.464,0,1,1-2.464-2.464,2.464,2.464,0,0,1,2.464,2.464Z",
    transform: "translate(11.941 39.243)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M91.728,228.864a2.464,2.464,0,1,1-2.464-2.464,2.464,2.464,0,0,1,2.464,2.464Z",
    transform: "translate(15.045 39.243)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M-51.272,243.724a2.452,2.452,0,0,1-.722,1.738,2.452,2.452,0,0,1-1.742.714,2.452,2.452,0,0,1-1.742-.714,2.452,2.452,0,0,1-.722-1.738,2.464,2.464,0,0,1,2.464-2.464A2.464,2.464,0,0,1-51.272,243.724Z",
    transform: "translate(-9.741 41.818)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M-33.412,243.724a2.452,2.452,0,0,1-.722,1.738,2.452,2.452,0,0,1-1.742.714,2.452,2.452,0,0,1-1.742-.714,2.452,2.452,0,0,1-.722-1.738,2.464,2.464,0,0,1,2.464-2.464A2.464,2.464,0,0,1-33.412,243.724Z",
    transform: "translate(-6.646 41.818)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M-15.542,243.724a2.452,2.452,0,0,1-.722,1.738,2.452,2.452,0,0,1-1.742.714,2.452,2.452,0,0,1-1.742-.714,2.452,2.452,0,0,1-.722-1.738,2.464,2.464,0,0,1,2.464-2.464A2.464,2.464,0,0,1-15.542,243.724Z",
    transform: "translate(-3.548 41.818)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "i",
    cx: 2.464,
    cy: 2.464,
    r: 2.464,
    transform: "translate(-3.051 283.078)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M20.2,243.724a2.452,2.452,0,1,1-.718-1.746,2.464,2.464,0,0,1,.718,1.746Z",
    transform: "translate(2.647 41.818)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M38.068,243.724a2.452,2.452,0,1,1-.718-1.746A2.464,2.464,0,0,1,38.068,243.724Z",
    transform: "translate(5.744 41.818)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M55.938,243.724a2.452,2.452,0,1,1-.714-1.742,2.464,2.464,0,0,1,.714,1.742Z",
    transform: "translate(8.842 41.818)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "i",
    cx: 2.464,
    cy: 2.464,
    r: 2.464,
    transform: "translate(80.819 283.078)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M91.728,243.724a2.452,2.452,0,1,1-.718-1.746A2.464,2.464,0,0,1,91.728,243.724Z",
    transform: "translate(15.045 41.818)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M-51.272,258.584a2.464,2.464,0,0,1-2.464,2.464,2.464,2.464,0,0,1-2.464-2.464,2.464,2.464,0,0,1,2.464-2.464A2.464,2.464,0,0,1-51.272,258.584Z",
    transform: "translate(-9.741 44.394)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M-33.412,258.584a2.464,2.464,0,0,1-2.464,2.464,2.464,2.464,0,0,1-2.464-2.464,2.464,2.464,0,0,1,2.464-2.464A2.464,2.464,0,0,1-33.412,258.584Z",
    transform: "translate(-6.646 44.394)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M-15.542,258.584a2.464,2.464,0,0,1-2.464,2.464,2.464,2.464,0,0,1-2.464-2.464,2.464,2.464,0,0,1,2.464-2.464A2.464,2.464,0,0,1-15.542,258.584Z",
    transform: "translate(-3.548 44.394)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M2.328,258.584a2.464,2.464,0,0,1-2.464,2.464A2.464,2.464,0,0,1-2.6,258.584,2.464,2.464,0,0,1-.136,256.12,2.464,2.464,0,0,1,2.328,258.584Z",
    transform: "translate(-0.451 44.394)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M20.2,258.584a2.464,2.464,0,1,1-2.464-2.464,2.464,2.464,0,0,1,2.464,2.464Z",
    transform: "translate(2.647 44.394)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M38.068,258.584A2.464,2.464,0,1,1,35.6,256.12,2.464,2.464,0,0,1,38.068,258.584Z",
    transform: "translate(5.744 44.394)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M55.938,258.584a2.464,2.464,0,1,1-2.452-2.464,2.464,2.464,0,0,1,2.452,2.464Z",
    transform: "translate(8.842 44.394)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M73.818,258.584a2.464,2.464,0,1,1-2.464-2.464A2.464,2.464,0,0,1,73.818,258.584Z",
    transform: "translate(11.941 44.394)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M91.728,258.584a2.464,2.464,0,1,1-2.464-2.464A2.464,2.464,0,0,1,91.728,258.584Z",
    transform: "translate(15.045 44.394)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M-51.272,273.444a2.464,2.464,0,0,1-2.464,2.464,2.464,2.464,0,0,1-2.464-2.464,2.464,2.464,0,0,1,2.464-2.464A2.464,2.464,0,0,1-51.272,273.444Z",
    transform: "translate(-9.741 46.97)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M-33.412,273.444a2.464,2.464,0,0,1-2.464,2.464,2.464,2.464,0,0,1-2.464-2.464,2.464,2.464,0,0,1,2.464-2.464A2.464,2.464,0,0,1-33.412,273.444Z",
    transform: "translate(-6.646 46.97)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M-15.542,273.444a2.464,2.464,0,0,1-2.464,2.464,2.464,2.464,0,0,1-2.464-2.464,2.464,2.464,0,0,1,2.464-2.464A2.464,2.464,0,0,1-15.542,273.444Z",
    transform: "translate(-3.548 46.97)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M2.328,273.44A2.464,2.464,0,0,1-.136,275.9,2.464,2.464,0,0,1-2.6,273.44,2.464,2.464,0,0,1-.136,271a2.464,2.464,0,0,1,2.464,2.441Z",
    transform: "translate(-0.451 46.973)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M20.2,273.444a2.464,2.464,0,1,1-2.464-2.464,2.464,2.464,0,0,1,2.464,2.464Z",
    transform: "translate(2.647 46.97)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M38.068,273.444A2.464,2.464,0,1,1,35.6,270.98,2.464,2.464,0,0,1,38.068,273.444Z",
    transform: "translate(5.744 46.97)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M55.938,273.444a2.464,2.464,0,1,1-2.452-2.464A2.464,2.464,0,0,1,55.938,273.444Z",
    transform: "translate(8.842 46.97)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M73.818,273.44A2.464,2.464,0,1,1,71.366,271a2.464,2.464,0,0,1,2.452,2.44Z",
    transform: "translate(11.941 46.973)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M91.728,273.444a2.464,2.464,0,1,1-2.464-2.464A2.464,2.464,0,0,1,91.728,273.444Z",
    transform: "translate(15.045 46.97)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M495.947,170.3a1.478,1.478,0,1,1-1.478-1.478A1.478,1.478,0,0,1,495.947,170.3Z",
    transform: "translate(85.451 29.262)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M506.647,170.3a1.478,1.478,0,1,1-1.478-1.478A1.478,1.478,0,0,1,506.647,170.3Z",
    transform: "translate(87.306 29.262)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M517.347,170.3a1.478,1.478,0,1,1-1.478-1.478A1.478,1.478,0,0,1,517.347,170.3Z",
    transform: "translate(89.161 29.262)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M528.047,170.3a1.478,1.478,0,1,1-1.478-1.478A1.478,1.478,0,0,1,528.047,170.3Z",
    transform: "translate(91.015 29.262)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M538.737,170.3a1.478,1.478,0,1,1-1.467-1.478,1.478,1.478,0,0,1,1.467,1.478Z",
    transform: "translate(92.868 29.262)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M549.437,170.3a1.478,1.478,0,1,1-1.467-1.478,1.478,1.478,0,0,1,1.467,1.478Z",
    transform: "translate(94.723 29.262)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "i",
    cx: 1.478,
    cy: 1.478,
    r: 1.478,
    transform: "translate(578.441 208.525)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "i",
    cx: 1.478,
    cy: 1.478,
    r: 1.478,
    transform: "translate(590.996 208.525)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "i",
    cx: 1.478,
    cy: 1.478,
    r: 1.478,
    transform: "translate(603.551 208.525)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M528.047,179.218a1.478,1.478,0,1,1-1.478-1.478,1.478,1.478,0,0,1,1.478,1.478Z",
    transform: "translate(91.015 30.808)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M538.737,179.218a1.467,1.467,0,1,1-.425-1.045A1.478,1.478,0,0,1,538.737,179.218Z",
    transform: "translate(92.868 30.808)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M549.437,179.218a1.467,1.467,0,1,1-.425-1.045A1.478,1.478,0,0,1,549.437,179.218Z",
    transform: "translate(94.723 30.808)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "i",
    cx: 1.478,
    cy: 1.478,
    r: 1.478,
    transform: "translate(578.441 218.967)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "i",
    cx: 1.478,
    cy: 1.478,
    r: 1.478,
    transform: "translate(590.996 218.967)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "i",
    cx: 1.478,
    cy: 1.478,
    r: 1.478,
    transform: "translate(603.551 218.967)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M528.047,188.087a1.478,1.478,0,1,1-1.478-1.467,1.478,1.478,0,0,1,1.478,1.467Z",
    transform: "translate(91.015 32.347)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M538.737,188.087a1.478,1.478,0,1,1-1.467-1.467,1.478,1.478,0,0,1,1.467,1.467Z",
    transform: "translate(92.868 32.347)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M549.437,188.087a1.478,1.478,0,1,1-1.467-1.467,1.478,1.478,0,0,1,1.467,1.467Z",
    transform: "translate(94.723 32.347)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M704.158,196.67a1.478,1.478,0,1,1-1.478,1.467A1.478,1.478,0,0,1,704.158,196.67Z",
    transform: "translate(121.798 34.089)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M704.158,186a1.478,1.478,0,1,1-1.478,1.478A1.478,1.478,0,0,1,704.158,186Z",
    transform: "translate(121.798 32.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M704.158,175.27a1.478,1.478,0,1,1-1.478,1.478A1.478,1.478,0,0,1,704.158,175.27Z",
    transform: "translate(121.798 30.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M704.158,164.57a1.478,1.478,0,1,1-1.478,1.478A1.478,1.478,0,0,1,704.158,164.57Z",
    transform: "translate(121.798 28.525)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M704.158,153.87a1.478,1.478,0,1,1-1.478,1.478,1.478,1.478,0,0,1,1.478-1.478Z",
    transform: "translate(121.798 26.671)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M704.158,143.17a1.478,1.478,0,1,1-1.478,1.478A1.478,1.478,0,0,1,704.158,143.17Z",
    transform: "translate(121.798 24.816)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "i",
    cx: 1.478,
    cy: 1.478,
    r: 1.478,
    transform: "translate(834.909 230.759)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "i",
    cx: 1.478,
    cy: 1.478,
    r: 1.478,
    transform: "translate(834.909 218.205)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "i",
    cx: 1.478,
    cy: 1.478,
    r: 1.478,
    transform: "translate(834.909 205.65)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M713.058,164.57a1.467,1.467,0,1,1-1.049.43,1.478,1.478,0,0,1,1.049-.43Z",
    transform: "translate(123.34 28.525)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M713.058,153.87a1.467,1.467,0,1,1-1.049.429,1.478,1.478,0,0,1,1.049-.429Z",
    transform: "translate(123.34 26.671)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "i",
    cx: 1.478,
    cy: 1.478,
    r: 1.478,
    transform: "translate(834.909 167.986)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "i",
    cx: 1.478,
    cy: 1.478,
    r: 1.478,
    transform: "translate(845.351 230.759)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "i",
    cx: 1.478,
    cy: 1.478,
    r: 1.478,
    transform: "translate(845.351 218.205)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "i",
    cx: 1.478,
    cy: 1.478,
    r: 1.478,
    transform: "translate(845.351 205.65)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M721.947,164.57a1.467,1.467,0,1,1-1.041.434,1.478,1.478,0,0,1,1.041-.434Z",
    transform: "translate(124.883 28.525)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M721.947,153.87a1.467,1.467,0,1,1-1.041.434,1.478,1.478,0,0,1,1.041-.434Z",
    transform: "translate(124.883 26.671)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "i",
    cx: 1.478,
    cy: 1.478,
    r: 1.478,
    transform: "translate(845.351 167.986)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M678.718,196.67a1.478,1.478,0,1,1-1.478,1.467A1.478,1.478,0,0,1,678.718,196.67Z",
    transform: "translate(117.388 34.089)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M678.718,186a1.478,1.478,0,1,1-1.478,1.478A1.478,1.478,0,0,1,678.718,186Z",
    transform: "translate(117.388 32.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M678.718,175.27a1.478,1.478,0,1,1-1.478,1.478A1.478,1.478,0,0,1,678.718,175.27Z",
    transform: "translate(117.388 30.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M678.718,164.57a1.478,1.478,0,1,1-1.478,1.478A1.478,1.478,0,0,1,678.718,164.57Z",
    transform: "translate(117.388 28.525)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M678.718,153.87a1.478,1.478,0,1,1-1.478,1.478,1.478,1.478,0,0,1,1.478-1.478Z",
    transform: "translate(117.388 26.671)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M678.718,143.17a1.478,1.478,0,1,1-1.478,1.478A1.478,1.478,0,0,1,678.718,143.17Z",
    transform: "translate(117.388 24.816)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "i",
    cx: 1.478,
    cy: 1.478,
    r: 1.478,
    transform: "translate(805.059 230.759)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "i",
    cx: 1.478,
    cy: 1.478,
    r: 1.478,
    transform: "translate(805.059 218.205)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "i",
    cx: 1.478,
    cy: 1.478,
    r: 1.478,
    transform: "translate(805.059 205.65)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M687.618,164.57a1.467,1.467,0,1,1-1.049.43,1.478,1.478,0,0,1,1.049-.43Z",
    transform: "translate(118.931 28.525)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M687.618,153.87a1.467,1.467,0,1,1-1.049.43,1.478,1.478,0,0,1,1.049-.43Z",
    transform: "translate(118.931 26.671)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "i",
    cx: 1.478,
    cy: 1.478,
    r: 1.478,
    transform: "translate(805.059 167.986)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "i",
    cx: 1.478,
    cy: 1.478,
    r: 1.478,
    transform: "translate(815.502 230.759)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "i",
    cx: 1.478,
    cy: 1.478,
    r: 1.478,
    transform: "translate(815.502 218.205)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "i",
    cx: 1.478,
    cy: 1.478,
    r: 1.478,
    transform: "translate(815.502 205.65)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M696.507,164.57a1.467,1.467,0,1,1-1.041.434A1.478,1.478,0,0,1,696.507,164.57Z",
    transform: "translate(120.473 28.525)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M696.507,153.87a1.467,1.467,0,1,1-1.041.434A1.478,1.478,0,0,1,696.507,153.87Z",
    transform: "translate(120.473 26.671)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "i",
    cx: 1.478,
    cy: 1.478,
    r: 1.478,
    transform: "translate(815.502 167.986)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "j",
    transform: "translate(248.465 -71.714)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M297.261-61.12a85.489,85.489,0,1,0,85.477,85.485A85.492,85.492,0,0,0,297.261-61.12Zm0,165.5a79.869,79.869,0,1,0-.008,0Z",
    transform: "translate(-211.76 61.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M294.531-45.37a67.009,67.009,0,1,0,67,67.005,67.012,67.012,0,0,0-67-67.005Zm0,123.763a56.806,56.806,0,1,1,.008,0Z",
    transform: "translate(-209.03 63.85)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M290.189-20.32a37.609,37.609,0,1,1-.008,0Zm0,57.8A20.193,20.193,0,1,1,310.382,17.3a20.193,20.193,0,0,1-20.193,20.181Z",
    transform: "translate(-204.688 68.192)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M669.612-30.15a60.732,60.732,0,1,0,60.732,60.732A60.732,60.732,0,0,0,669.612-30.15Zm0,109.93a49.2,49.2,0,1,1,49.2-49.2,49.2,49.2,0,0,1-49.2,49.2Z",
    transform: "translate(105.539 -5.226)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "f",
    transform: "translate(713.898 274.553)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M698.693,263.75c-9.011,2.957-16.943-5.691-25.543-7.732a20.381,20.381,0,0,0-10.713.34c-4.083,1.173-7.415,4.283-11.252,6.371-7.943,4.33-15.981,1.877-22.927-4.482-2.687-2.464-5.468-4.94-8.741-5.233-3.9-.329-7.533,2.253-10.642,5.3-1.056,1.033,0,3.52,1.009,2.464,3.931-3.849,8.436-6.524,13.106-3.6,3.309,2.065,6.054,5.573,9.387,7.627a19.043,19.043,0,0,0,20.146.211c3.813-2.265,7.228-5.139,11.358-6.172a20.146,20.146,0,0,1,13.27,1.5c7.286,3.262,14.256,8.73,22.106,6.148C700.489,266.073,699.961,263.328,698.693,263.75Z",
    transform: "translate(-608.436 -230.702)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M698.693,254.249c-9.011,2.968-16.943-5.679-25.543-7.732a20.381,20.381,0,0,0-10.713.34c-4.083,1.173-7.415,4.283-11.252,6.371-7.943,4.33-15.981,1.877-22.927-4.482-2.687-2.464-5.468-4.94-8.741-5.221-3.9-.34-7.533,2.241-10.642,5.292-1.056,1.033,0,3.52,1.009,2.464,3.931-3.849,8.436-6.524,13.106-3.6,3.309,2.065,6.054,5.573,9.387,7.627a19.043,19.043,0,0,0,20.146.211c3.813-2.265,7.228-5.139,11.358-6.172a20.146,20.146,0,0,1,13.27,1.5c7.286,3.262,14.256,8.73,22.106,6.148C700.489,256.572,699.961,253.826,698.693,254.249Z",
    transform: "translate(-608.436 -232.348)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M698.693,244.749c-9.011,2.969-16.943-5.679-25.543-7.732a20.381,20.381,0,0,0-10.713.34c-4.083,1.173-7.415,4.283-11.252,6.371-7.943,4.341-15.981,1.877-22.927-4.482-2.687-2.464-5.468-4.94-8.741-5.221-3.9-.34-7.533,2.241-10.642,5.292-1.056,1.033,0,3.52,1.009,2.464,3.931-3.849,8.436-6.524,13.106-3.6,3.309,2.065,6.054,5.573,9.387,7.627a19.043,19.043,0,0,0,20.146.211c3.813-2.265,7.228-5.139,11.358-6.172a20.216,20.216,0,0,1,13.271,1.5c7.286,3.262,14.256,8.73,22.106,6.148C700.489,247.084,699.961,244.338,698.693,244.749Z",
    transform: "translate(-608.436 -233.994)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M228.555,346.7v15.429H187.43V321h15.418v25.7Z",
    transform: "translate(-47.756 -16.074)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M530.355,182.208v15.429H489.23V156.5h15.429v25.708Z",
    transform: "translate(4.555 -44.588)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M554.1,158.468V173.9H512.96V132.76h15.429v25.708Z",
    transform: "translate(8.669 -48.702)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M577.825,134.726v15.429H536.7V109.03h15.429v25.7Z",
    transform: "translate(12.784 -52.816)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M601.567,111v15.429H560.43V85.29h15.429V111Z",
    transform: "translate(16.897 -56.931)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M315.262,268.412A26.815,26.815,0,1,1,277.34,230.49Z",
    transform: "translate(46.711 39.952)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M206.477,104.072c-4.306,7.521-12.367,7.662-18.421,2.347-2.793-2.464-5.28-5.362-8.835-6.758a13.869,13.869,0,0,0-10.337.094c-4.365,1.807-6.172,5.679-9.387,8.823-2.663,2.617-6.594,4.482-10.29,2.558-2.5-1.314-3.59-4.353-5.444-6.336a13.916,13.916,0,0,0-8.378-4.224c-7.193-.939-12.989,3.755-15.382,10.243-1,2.71,3.321,3.872,4.306,1.173,2.523-6.864,10.889-9.668,16.3-4.06,2.933,3.051,4,6.465,8.331,7.873,7.65,2.487,12.578-3.215,17.119-8.213,10.185-11.311,16.239,3.039,25.438,6.289,7.509,2.652,15.007-.892,18.832-7.556C211.768,103.826,207.908,101.573,206.477,104.072Z",
    transform: "translate(20.775 17.109)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M206.477,117.961c-4.306,7.521-12.367,7.662-18.421,2.347-2.793-2.452-5.28-5.35-8.835-6.747a13.869,13.869,0,0,0-10.337.094c-4.365,1.8-6.172,5.679-9.387,8.812-2.663,2.617-6.594,4.494-10.29,2.558-2.5-1.3-3.59-4.353-5.444-6.324a14,14,0,0,0-8.378-4.236c-7.193-.927-12.989,3.766-15.382,10.255-1,2.7,3.321,3.872,4.306,1.173,2.523-6.852,10.889-9.657,16.3-4.048,2.933,3.051,4,6.465,8.331,7.873,7.65,2.487,12.578-3.215,17.119-8.213,10.185-11.311,16.239,3.039,25.438,6.277,7.509,2.652,15.007-.88,18.832-7.545C211.768,117.761,207.908,115.415,206.477,117.961Z",
    transform: "translate(20.775 19.519)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-61.84 -73.871)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M603.149,558.437H511.206a3.891,3.891,0,0,1-3.886-3.891h0a3.891,3.891,0,0,1,3.886-3.886h91.943a3.886,3.886,0,0,1,3.886,3.886h0a3.886,3.886,0,0,1-3.886,3.891Z",
    transform: "translate(-243.293 -229.961)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "p",
    width: 20.404,
    height: 7.777,
    rx: 3.888,
    transform: "translate(302.02 236.346)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M512.632,325.107H378.946a3.886,3.886,0,0,1-3.886-3.891h0a3.886,3.886,0,0,1,3.886-3.886H512.632a3.891,3.891,0,0,1,3.886,3.886h0A3.891,3.891,0,0,1,512.632,325.107Z",
    transform: "translate(-172.956 -105.873)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M686.025,157.387H640.761a3.891,3.891,0,0,1-3.891-3.891h0a3.891,3.891,0,0,1,3.891-3.886h45.264a3.891,3.891,0,0,1,3.886,3.886h0a3.891,3.891,0,0,1-3.886,3.891Z",
    transform: "translate(-312.189 -16.678)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M634.145,126.027h-5.014a3.886,3.886,0,0,1-3.891-3.886h0a3.891,3.891,0,0,1,3.891-3.891h5.014a3.891,3.891,0,0,1,3.891,3.891h0a3.886,3.886,0,0,1-3.891,3.886Z",
    transform: "translate(-306.004 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M381.943,346.784,337.465,152.079a4.8,4.8,0,0,0-5.749-3.628l-1.166.267h-.033l-46.819,10.7-1.4-6.119a1.826,1.826,0,0,0-2.2-1.376l-15.034,3.436a1.873,1.873,0,0,1-2.135-1.18,12.267,12.267,0,0,0-23.7,5.417,1.845,1.845,0,0,1-1.4,1.985L223.9,164.757a1.835,1.835,0,0,0-1.376,2.2l1.4,6.119-48.495,11.1a4.34,4.34,0,0,0-3.277,5.192l44.689,195.614a4.335,4.335,0,0,0,5.188,3.277l155.087-35.428h0l1.194-.272a4.8,4.8,0,0,0,3.629-5.768ZM250.026,152.308a6.339,6.339,0,1,1-4.771,7.594A6.339,6.339,0,0,1,250.026,152.308Z",
    transform: "translate(-64.992 -14.867)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "r",
    width: 167.747,
    height: 209.322,
    rx: 10.25,
    transform: "translate(106.934 168.011) rotate(-12.87)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M333.725,150.76l44.684,195.614a4.331,4.331,0,0,1-3.277,5.188L220.063,386.99a4.335,4.335,0,0,1-5.187-3.277l-44.689-195.6a4.34,4.34,0,0,1,3.277-5.192L328.547,147.5a4.335,4.335,0,0,1,5.192,3.277Z",
    transform: "translate(-63.945 -15.497)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M331.97,148.14,216.631,386.321a4.312,4.312,0,0,1-1.756-2.594L170.187,188.114a4.34,4.34,0,0,1,3.277-5.192l155.083-35.428A4.331,4.331,0,0,1,331.97,148.14Z",
    transform: "translate(-63.945 -15.493)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M336.669,166.22l39.1,171.156L363,357.714,229.117,388.3,186.24,200.585Z",
    transform: "translate(-72.539 -25.511)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M572.245,531.79l-12.772,20.338-3.783-16.555Z",
    transform: "translate(-269.017 -219.925)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "M227.577,295.226,222.6,273.437l21.79-4.977,4.982,21.789Zm-.468-18.971,3.31,14.486,14.467-3.3-3.31-14.514Z",
    transform: "translate(-91.876 -79.883)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M242.483,296.474l-4.663-2.931,1.245-1.98,2.683,1.681,6.292-10.024,1.985,1.245Z",
    transform: "translate(-99.97 -87.733)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "w",
    width: 42.708,
    height: 3.989,
    transform: "translate(159.324 188.774) rotate(-12.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "y",
    width: 100.225,
    height: 3.989,
    transform: "translate(160.984 196.053) rotate(-12.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "y",
    width: 83.45,
    height: 3.989,
    transform: "translate(162.614 203.18) rotate(-12.87)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "M243.757,366.051l-4.977-21.794,21.789-4.977,5,21.794Zm-.468-18.976,3.31,14.49,14.486-3.31-3.305-14.49Z",
    transform: "translate(-100.48 -117.546)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M258.663,367.3,254,364.374l1.245-1.985,2.678,1.685,6.3-10.024,1.98,1.245Z",
    transform: "translate(-108.575 -125.401)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "w",
    width: 42.708,
    height: 3.989,
    transform: "translate(166.895 221.935) rotate(-12.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "y",
    width: 100.225,
    height: 3.989,
    transform: "translate(168.56 229.213) rotate(-12.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "y",
    width: 31.762,
    height: 3.989,
    transform: "translate(170.19 236.341) rotate(-12.87)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "M259.958,436.876,255,415.087l21.79-4.977,4.977,21.79Zm-.468-18.971,3.31,14.486,14.486-3.31-3.31-14.486Z",
    transform: "translate(-109.106 -155.214)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "z",
    width: 13.006,
    height: 2.341,
    transform: "translate(154.806 273.17) rotate(-57.86)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "z",
    width: 2.341,
    height: 13.006,
    transform: "matrix(0.532, -0.847, 0.847, 0.532, 153.128, 265.796)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "w",
    width: 42.708,
    height: 3.989,
    transform: "translate(174.474 255.091) rotate(-12.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "y",
    width: 100.225,
    height: 3.989,
    transform: "translate(176.134 262.374) rotate(-12.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "y",
    width: 67.569,
    height: 3.989,
    transform: "translate(177.764 269.496) rotate(-12.87)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "M276.117,507.7l-4.977-21.794,21.789-4.977,4.977,21.79Zm-.468-18.976,3.31,14.49,14.486-3.31-3.31-14.514Z",
    transform: "translate(-117.69 -192.877)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "z",
    width: 13.006,
    height: 2.341,
    transform: "translate(162.382 306.332) rotate(-57.86)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "z",
    width: 2.341,
    height: 13.006,
    transform: "matrix(0.532, -0.847, 0.847, 0.532, 160.704, 298.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "w",
    width: 42.708,
    height: 3.989,
    transform: "translate(182.049 288.251) rotate(-12.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "y",
    width: 100.225,
    height: 3.989,
    transform: "translate(183.713 295.529) rotate(-12.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "y",
    width: 93.788,
    height: 3.989,
    transform: "translate(185.343 302.658) rotate(-12.87)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "M292.347,578.521l-4.977-21.789,21.789-4.982,4.977,21.794Zm-.515-18.976,3.31,14.514,14.486-3.31-3.31-14.491Z",
    transform: "translate(-126.321 -230.54)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M307.2,579.77l-4.658-2.926,1.241-1.985,2.683,1.685,6.3-10.024,1.98,1.245Z",
    transform: "translate(-134.389 -238.395)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "w",
    width: 42.708,
    height: 3.989,
    transform: "translate(189.624 321.411) rotate(-12.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "y",
    width: 100.225,
    height: 3.989,
    transform: "translate(191.289 328.69) rotate(-12.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "y",
    width: 83.45,
    height: 3.989,
    transform: "translate(192.918 335.816) rotate(-12.87)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M337.038,148.41a1.845,1.845,0,0,0-1.657-.44l-15.034,3.437a1.873,1.873,0,0,1-2.135-1.18,12.267,12.267,0,0,0-23.7,5.417,1.845,1.845,0,0,1-1.4,1.985l-13.919,3.179a1.835,1.835,0,0,0-1.376,2.2l3.507,15.357a11.19,11.19,0,0,0,13.381,8.4l37.993-8.68a11.171,11.171,0,0,0,8.39-13.381l-3.507-15.357A1.873,1.873,0,0,0,337.038,148.41Zm-31.729-.075a6.339,6.339,0,1,1-4.771,7.594,6.339,6.339,0,0,1,4.771-7.594Z",
    transform: "translate(-121.211 -12.767)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ab",
    d: "M335.381,147.97l-15.034,3.436a1.873,1.873,0,0,1-2.135-1.18,12.267,12.267,0,0,0-23.7,5.417,1.845,1.845,0,0,1-1.4,1.985l-13.919,3.179a1.835,1.835,0,0,0-1.376,2.2l3.507,15.357a11.077,11.077,0,0,0,4.265,6.5l51.459-36.448a1.845,1.845,0,0,0-1.657-.44ZM308.132,160.7a6.339,6.339,0,1,1,3.962-2.807,6.339,6.339,0,0,1-3.962,2.807Z",
    transform: "translate(-121.211 -12.767)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M654.71,440.7h0l-3.1-22.5h0l-10.057,1.386h0L607.9,424.221l3.1,22.5h0v0l33.653-4.635,10.052-1.386Z",
    transform: "translate(-296.783 -159.517)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ac",
    width: 44.122,
    height: 22.717,
    transform: "translate(311.163 261.693) rotate(-8.049)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "u",
    width: 10.15,
    height: 22.713,
    transform: "translate(344.785 256.943) rotate(-8.049)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M575.293,195.751a35.582,35.582,0,1,0-9.593,5.618l2.275,5.272a4.832,4.832,0,0,0,6.85,2.271l2.477-1.428a4.832,4.832,0,0,0,1.465-7.065Z",
    transform: "translate(-248.519 -7.656)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ad",
    d: "M585.226,162.18a35.62,35.62,0,1,1-10.815-25.563A35.62,35.62,0,0,1,585.226,162.18Z",
    transform: "translate(-246.836 -4.419)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ae",
    d: "M600.088,173.582a35.629,35.629,0,0,1-58.158,27.586L589.273,148a35.531,35.531,0,0,1,10.815,25.582Z",
    transform: "translate(-261.699 -15.821)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "af",
    d: "M627.488,257.889l-7.379-9.968a4.827,4.827,0,0,0-6.292-1.306h0a4.827,4.827,0,0,0-2.023,6.086l4.921,11.4a4.832,4.832,0,0,0,6.85,2.271l2.477-1.428a4.832,4.832,0,0,0,1.447-7.051Z",
    transform: "translate(-298.645 -67.921)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "af",
    cx: 29.168,
    cy: 29.168,
    r: 29.168,
    transform: "matrix(0.972, -0.234, 0.234, 0.972, 267.431, 136.105)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "ag",
    cx: 25.343,
    cy: 25.343,
    r: 25.343,
    transform: "translate(266.765 157.656) rotate(-45)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "ah",
    cx: 22.969,
    cy: 22.969,
    r: 22.969,
    transform: "matrix(0.909, -0.417, 0.417, 0.909, 272.151, 146.348)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "ai",
    cx: 19.566,
    cy: 19.566,
    r: 19.566,
    transform: "translate(275.504 142.667) rotate(-14.37)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "aj",
    cx: 10.998,
    cy: 10.998,
    r: 10.998,
    transform: "matrix(0.357, -0.934, 0.934, 0.357, 288.409, 164.006)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(105.86 291.419)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "ak",
    x2: 75.993,
    transform: "translate(0 37.997)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "ak",
    x2: 75.993,
    transform: "translate(37.997 0) rotate(90)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(102.445 288.003)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "al",
    x2: 75.993,
    transform: "translate(0 37.997)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "al",
    x2: 75.993,
    transform: "translate(37.997 0) rotate(90)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalculator);
export default __webpack_public_path__ + "static/media/calculator.3adc0706f63217d0b0d1f9eddde538d3.svg";
export { ForwardRef as ReactComponent };